// /* global google */
// /* global gapi */
// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
//   useMemo,
// } from "react";
// import { FaSearch } from "react-icons/fa";
// import Cookies from "js-cookie";
// import { toast } from "react-toastify"; // Import toast
// import PickFilesButton from "../chat/PickFilesButton";
// import api from "../chat/api";
// import { useNavigate } from "react-router-dom";
// import { Header } from "../../components/Header/Header";
// import UploadModal from "../Contract/UploadModal";
// import FilterModal from "../Contract/filterModal";
// import bell from "../../Images/ai-bell.png";
// import search from "../../Images/search-big.jpg";
// import axios from "axios";
// import "../Contract/contract_data.css";
// import Spinner from "../Contract/Spinner";
// import CustomDropdown from "../Contract/CustomDropdown";
// import { getFreshAccessToken } from "../chat/api";
// import useGooglePicker from "../Ocr_Data/useGooglePicker";
// const ContractTable = ({ isMenuOpen }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBulkDelete, setIsBulkDelete] = useState(false);
//   const [exportInProgress, setExportInProgress] = useState(false);
//   const [invoices, setinvoices] = useState([]);
//   const [token, setToken] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
//   const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
//   const [editContractId, setEditContractId] = useState(null);
//   const [editedContractData, setEditedContractData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const editRowRef = useRef(null);
//   const [selectedinvoices, setSelectedinvoices] = useState([]);
//   const [selectedContractKeys, setSelectedContractKeys] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [popupTitle, setPopupTitle] = useState("");
//   const [popupMessage, setPopupMessage] = useState("");
//   const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
//   const [contractToDelete, setContractToDelete] = useState(null);
//   const actionMenuRef = useRef(null);
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [isFilterApplied, setIsFilterApplied] = useState(false);
//   const [filterType, setFilterType] = useState("");
//   const [timeRange, setTimeRange] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [file, setFile] = useState(null);
//   const fileInputRef = useRef(null);
//   const [isSearchFocused, setIsSearchFocused] = useState(false);
//   const [hoveredAction, setHoveredAction] = useState(null);
//   const [clickedAction, setClickedAction] = useState(null);
//   const [invoice_name, setInvoiceName] = useState("");
//   const [actionMenuPosition, setActionMenuPosition] = useState({
//     top: 0,
//     left: 0,
//     openUpwards: false,
//   });

//   const { isConnected, connect, disconnect, openPicker, accessToken } = useGooglePicker();
//   const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const [deleteInProgress, setDeleteInProgress] = useState(false);
//   const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
//   const [isCustomApplyFieldModal, setIsCustomApplyFiledModal] = useState(false);
//   const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
//   const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
//   const [selectedTab, setSelectedTab] = useState("manage");
//   const [fieldName, setFieldName] = useState("");
//   const [fieldPrompt, setFieldPrompt] = useState("");
//   const [customFields, setCustomFields] = useState([]);
//   const [loadingAddField, setLoadingAddField] = useState(false);
//   const [deletingField, setDeletingField] = useState(null);
//   const isMaxFieldsReached = customFields.length >= 5;
//   const isFilled = fieldName.trim() && fieldPrompt.trim();
//   const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
//   const moreButtonRef = useRef(null);
//   const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
//   const [isCreatingNew, setIsCreatingNew] = useState(false);
//   const [selectedField, setSelectedField] = useState("");
//   const [newFieldName, setNewFieldName] = useState("");
//   const [newPrompt, setNewPrompt] = useState("");
//   const baseColumns = 7; // name, party A, party B, date, etc.
//   const totalColumns = baseColumns + customFields.length;
//   const uploadButtonRef = useRef(null);
//   const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });

//   const [customFieldPopup, setCustomFieldPopup] = useState({
//     visible: false,
//     value: "",
//     contractKey: "",
//     contractId: "",
//     x: 0,
//     y: 0,
//   });
//   const popupRef = useRef(null);
//   const minWidthPercent = totalColumns * 15; // e.g., 9 * 15 = 135
//   const [isLoading, setIsLoading] = useState(false);
//   const handleFileChange = (event) => {
//     const selectedFiles = Array.from(event.target.files || []);
//     if (selectedFiles.length === 0) return;

//     setFile(selectedFiles); // ✅ save to state
//     setIsModalOpen(true);
//   };
//   const [filterApplied, setFilterApplied] = useState(false);
//   const navigate = useNavigate();
//   const handleFilterApply = (filteredInvoices, filterData) => {
//     setinvoices(filteredInvoices);
//     setIsFilterApplied(true);
//     setFilterType(filterData.filterType);
//     setTimeRange(filterData.timeRange);
//     setFromDate(filterData.fromDate);
//     setToDate(filterData.toDate);
//     toggleFilterModal();
//   };

//   const loadGoogleAPI = () => {
//     const script = document.createElement("script");
//     script.src = "https://apis.google.com/js/api.js";
//     script.async = true;
//     script.onload = () => {
//       window.gapi.load("client:picker", () => {
//         console.log("Google Picker API is ready.");
//       });
//     };
//     document.body.appendChild(script);
//   };

//   useEffect(() => {
//     loadGoogleAPI(); // Load the Google API when the component mounts
//   }, []);

//   useEffect(() => {
//     const cookieToken = Cookies.get("access_token");
//     if (cookieToken) {
//       setToken(cookieToken);
//     } else {
//       console.error("Access token missing from cookies");
//     }
//   }, []);

//   const toggleModal = () => {
//     setIsModalOpen((prev) => !prev);
//   };

//   const handleExport = async () => {
//     if (!selectedinvoices || selectedinvoices.length === 0) {
//       showPopup("Error", "Please select at least one invoice to export.");
//       return;
//     }

//     setExportInProgress(true);

//     try {
//       const response = await api.post(
//         `api/v1/invoice/export-invoice/`,
//         { invoice_keys: selectedContractKeys },
//         { responseType: "blob" }
//       );

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "invoices_export.csv");
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // showPopup("Success", "Invoices exported successfully.");
//       setSelectedinvoices([]);
//       setSelectedContractKeys([]);
//       setIsBulkDelete(false);
//     } catch (error) {
//       if (error.response) {
//         const message =
//           error.response.data?.msg || "Failed to export invoices.";
//         showPopup("Error", message);
//       } else {
//         showPopup("Error", "An unexpected error occurred. Please try again.");
//       }
//     } finally {
//       setExportInProgress(false);
//     }
//   };

//   const handleCancel = () => {
//     setSelectedinvoices([]);

//     setIsModalOpen(false);
//     setIsFilterModalOpen(false);
//     setPopupVisible(false);

//     setConfirmDeleteVisible(false);
//   };
//   const handleToggleMore = () => {
//     if (isActionMenuOpen === "more") {
//       setIsActionMenuOpen(null);
//     } else {
//       const rect = moreButtonRef.current.getBoundingClientRect();
//       setDropdownCoords({
//         top: rect.bottom + window.scrollY + 6, // Add spacing
//         left: rect.left + window.scrollX, // Align horizontally
//       });
//       setIsActionMenuOpen("more");
//     }
//   };

//   const handleDeleteField = async (fieldId) => {
//     try {
//       await api.delete(`/api/v1/invoice/delete-field/${fieldId}/`);
//       await fetchCustomFields(); // refresh after deletion
//     } catch (error) {
//       console.error("Error deleting field", error);
//     } finally {
//       setDeletingField(null);
//     }
//   };


  
// useEffect(() => {
//   if (isConnected && !hasOpenedPickerOnce) {
//     // Don't open picker here
//     setHasOpenedPickerOnce(true);
//   }
// }, [isConnected, hasOpenedPickerOnce]);
// const handleAddFromDriveClick = () => {
//   openPicker(async (docs) => {
//     console.log("📄 Files picked:", docs);

//     try {
//       const files = await Promise.all(
//         docs.map(async (doc) => {
//           const res = await fetch(`https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`, {
//             headers: { Authorization: `Bearer ${accessToken}` },
//           });

//           if (!res.ok) throw new Error("Failed to fetch file from Drive");

//           const blob = await res.blob();
//           return new File([blob], doc.name, { type: blob.type });
//         })
//       );

//       setFile(files); // 👈 trigger your upload flow
//       setIsModalOpen(true); // 👈 open modal
//     } catch (err) {
//       console.error("Failed to process selected files", err);
//       toast.error("Something went wrong while processing selected files.");
//     }
//   });
// };

//   const handleAddField = async () => {
//     if (!fieldName.trim() || !fieldPrompt.trim()) return;
//     try {
//       setLoadingAddField(true);
//       await api.post("/api/v1/invoice/create-field/", {
//         field: fieldName.trim(),
//         description: fieldPrompt.trim(),
//       });

//       setFieldName("");
//       setFieldPrompt("");
//       await fetchCustomFields();
//       await fetchinvoices();
//       // show inline success message near button
//       setFieldCreationSuccess(true);

//       setTimeout(() => setFieldCreationSuccess(false), 5000);
//       setSelectedTab("manage");
//       setIsCustomFieldModalOpen(false);
//     } catch (error) {
//       console.error("Error adding field", error);
//     } finally {
//       setLoadingAddField(false);
//     }
//   };



//   const fetchinvoices = useCallback(async () => {
//     if (!token) return;
//     setLoading(true);

//     try {
//       let url = `api/v1/invoice/invoices/`;

//       if (isFilterApplied) {
//         url = `api/v1/invoice/filter-invoice/`;

//         const params = {
//           filter_type: filterType,
//           time_range: timeRange,
//           from_date: fromDate,
//           to_date: toDate,
//         };

//         const response = await api.get(url, { params });
//         setinvoices(response.data.invoices || []);
//       } else {
//         const response = await api.get(url); // clean, no headers needed
//         setinvoices(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching invoices:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [token, isFilterApplied, filterType, timeRange, fromDate, toDate]);

//   const tableBodyRef = useRef(null);

//   const scrollToTop = () => {
//     if (tableBodyRef.current) {
//       tableBodyRef.current.scrollTop = 0;
//     }
//   };

//   const handleSelectAll = () => {
//     if (selectedinvoices.length === invoices.length) {
//       setSelectedinvoices([]);
//       setSelectedContractKeys([]);
//     } else {
//       setSelectedinvoices(invoices.map((contract) => contract.id));
//       setSelectedContractKeys(invoices.map((contract) => contract.key));
//     }
//   };

//   const filteredinvoices = useMemo(() => {
//     const query = searchQuery?.toLowerCase() || "";
//     return invoices.filter((invoice) => {
//       const invoiceName = invoice?.name?.toLowerCase() || "";
//       const customerName =
//         invoice?.details?.["Customer name"]?.toLowerCase() || "";
//       const vendorName = invoice?.details?.["Vendor name"]?.toLowerCase() || "";

//       return (
//         invoiceName.includes(query) ||
//         customerName.includes(query) ||
//         vendorName.includes(query)
//       );
//     });
//   }, [invoices, searchQuery]);

//   const indexOfLastContract = currentPage * rowsPerPage;
//   const indexOfFirstContract = indexOfLastContract - rowsPerPage;
//   const currentinvoices = useMemo(() => {
//     const indexOfLastContract = currentPage * rowsPerPage;
//     const indexOfFirstContract = indexOfLastContract - rowsPerPage;
//     return filteredinvoices.slice(indexOfFirstContract, indexOfLastContract);
//   }, [filteredinvoices, currentPage, rowsPerPage]);

//   const totalPages = useMemo(
//     () => Math.ceil(filteredinvoices.length / rowsPerPage),
//     [filteredinvoices, rowsPerPage]
//   );
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(Number(event.target.value));
//     setCurrentPage(1);
//   };

//   const handleCheckboxChange = (id, key) => {
//     if (selectedinvoices.includes(id)) {
//       setSelectedinvoices(
//         selectedinvoices.filter((contractId) => contractId !== id)
//       );
//       setSelectedContractKeys(
//         selectedContractKeys.filter((contractKey) => contractKey !== key)
//       );
//     } else {
//       setSelectedinvoices([...selectedinvoices, id]);
//       setSelectedContractKeys([...selectedContractKeys, key]);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchinvoices();
//     }
//   }, [
//     fetchinvoices,
//     token,
//     isFilterApplied,
//     filterType,
//     timeRange,
//     fromDate,
//     toDate,
//   ]);

//   useEffect(() => {
//     if (isFilterApplied) {
//       localStorage.setItem(
//         "invoiceFilter",
//         JSON.stringify({ filterType, timeRange, fromDate, toDate })
//       );
//     }
//   }, [isFilterApplied, filterType, timeRange, fromDate, toDate]);

//   const tbodyRef = useRef(null);
//   useEffect(() => {
//     const calculateRowsPerPage = () => {
//       if (tbodyRef.current) {
//         const containerHeight = tbodyRef.current.clientHeight;

//         const headerHeight = 52; // height of the <thead> row (approx)
//         const rowHeight = 44; // your row height from <tr className="h-[44px]">

//         const visibleHeight = containerHeight - headerHeight;
//         const calculatedRows = Math.floor(visibleHeight / rowHeight);

//         if (calculatedRows > 0) {
//           setRowsPerPage(calculatedRows);
//         }
//       }
//     };

//     calculateRowsPerPage(); // On mount

//     window.addEventListener("resize", calculateRowsPerPage); // On resize

//     return () => window.removeEventListener("resize", calculateRowsPerPage);
//   }, []);

//   // useEffect(() => {
//   //   const storedFilters = JSON.parse(localStorage.getItem("invoiceFilter"));
//   //   if (storedFilters) {
//   //     setFilterType(storedFilters.filterType);
//   //     setTimeRange(storedFilters.timeRange);
//   //     setFromDate(storedFilters.fromDate);
//   //     setToDate(storedFilters.toDate);
//   //     setIsFilterApplied(true);
//   //   }
//   // }, []);

//   const formatDates = (dateString) => {
//     if (!dateString) return "N/A";

//     const date = new Date(dateString);

//     if (isNaN(date)) return "N/A"; // handle invalid date

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };
//   const handleUploadSuccess = () => {
//     fetchinvoices();
//     toggleModal();
//   };

//   const handleCloseModal = () => {
//     toggleModal();
//     fetchinvoices();
//   };

//   const handlePageChange = (event) => {
//     const newPage = Number(event.target.value);
//     if (newPage > 0 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//     }
//   };

//   const toggleActionMenu = (index, event) => {
//     const menuHeight = 150; // Approximate height of the action menu
//     const rect = event.currentTarget.getBoundingClientRect();
//     const bottomSpace = window.innerHeight - rect.bottom;

//     const openUpwards = bottomSpace < menuHeight;

//     setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
//     setActionMenuPosition({
//       top: openUpwards ? rect.top - menuHeight : rect.bottom,
//       left: rect.left,
//       openUpwards,
//     });
//   };

//   const toggleFilterModal = () => {
//     setIsFilterModalOpen((prev) => !prev);
//   };

//   const handleViewMore = (invoiceKey) => {
//     navigate(`/Invoices/Invoice_Details/${invoiceKey}`);
//   };

//   const enableEdit = (invoice) => {
//     if (invoice) {
//       setIsActionMenuOpen(null);
//       setEditContractId(invoice.id);

//       const formatDateForInput = (dateString) => {
//         if (!dateString) return "";

//         const parsedDate = new Date(dateString);

//         // Check if the parsed date is valid
//         if (isNaN(parsedDate.getTime())) return "";

//         const year = parsedDate.getFullYear();
//         const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
//         const day = String(parsedDate.getDate()).padStart(2, "0");

//         return `${year}-${month}-${day}`;
//       };

//       const extractAmountAndCurrency = (amount) => {
//         if (!amount) return { value: "", currency: "" };

//         const match = amount.toString().match(/^([\D]*)([\d,\.]+)$/);
//         if (match) {
//           return {
//             currency: match[1].trim(),
//             value: match[2].trim().replace(",", "."),
//           };
//         }
//         return { value: amount, currency: "" };
//       };

//       const { value, currency } = extractAmountAndCurrency(
//         invoice.details?.["Total due amount"]
//       );

//       setEditedContractData({
//         ...invoice,
//         details: {
//           ...invoice.details,
//           "Issued on": formatDateForInput(invoice.details?.["Issued on"]),
//           "Due date": formatDateForInput(invoice.details?.["Due date"]),
//           "Total due amount": value,
//           Currency: currency,
//         },
//       });
//       setInvoiceName(invoice.name || "");
//     } else {
//       setEditContractId(null);
//       setEditedContractData({});
//       setInvoiceName("");
//     }
//   };
//   useEffect(() => {
//     fetchCustomFields(); // Fetch custom fields when component mounts
//   }, []);

//   const fetchCustomFields = async () => {
//     try {
//       setCustomFieldsLoading(true);
//       const res = await api.get("/api/v1/invoice/list-field/");
//       setCustomFields(res.data || []);
//     } catch (err) {
//       console.error("Error fetching fields", err);
//     } finally {
//       setCustomFieldsLoading(false);
//     }
//   };

//   const handleApplyField = async () => {
//     setIsLoading(true);

//     const selectedFieldObj = customFields.find(
//       (field) => field.field === selectedField
//     );

//     const payload = isCreatingNew
//       ? {
//           new_field: {
//             field: newFieldName,
//             description: newPrompt,
//           },
//           invoice_keys: selectedContractKeys,
//         }
//       : {
//           field_id: selectedFieldObj?.id, // ✅ send ID, not name
//           invoice_keys: selectedContractKeys,
//         };

//     if (!isCreatingNew && !payload.field_id) {
//       console.error("Invalid field selected.");
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const res = await api.post("api/v1/invoice/apply-field/", payload);
//       setIsCustomApplyFiledModal(false);
//       await fetchinvoices();
//       await fetchCustomFields();

//       setSelectedinvoices([]);
//       setSelectedContractKeys([]);
//     } catch (err) {
//       console.error("Error:", err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleEditChange = (fieldPath, value) => {
//     if (fieldPath.startsWith("details._custom_fields.")) {
//       const key = fieldPath.split(".")[2];
//       setEditedContractData((prev) => ({
//         ...prev,
//         details: {
//           ...prev.details,
//           _custom_fields: {
//             ...(prev.details?._custom_fields || {}),
//             [key]: value,
//           },
//         },
//       }));
//     } else if (fieldPath.startsWith("details.")) {
//       const key = fieldPath.split(".")[1];
//       setEditedContractData((prev) => ({
//         ...prev,
//         details: {
//           ...prev.details,
//           [key]: value,
//         },
//       }));
//     } else {
//       setEditedContractData((prev) => ({
//         ...prev,
//         [fieldPath]: value,
//       }));
//     }
//   };

//   const handleClickOutside = (event) => {
//     if (
//       actionMenuRef.current &&
//       !actionMenuRef.current.contains(event.target)
//     ) {
//       setIsActionMenuOpen(null);
//     }
//     if (
//       confirmDeleteVisible &&
//       event.target.closest(".popup-overlay") === null &&
//       !event.target.closest(".popup-box-delete")
//     ) {
//       setConfirmDeleteVisible(false);
//     }
//   };
//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [confirmDeleteVisible, isActionMenuOpen]);

//   const showPopup = (title, message) => {
//     setPopupTitle(title);
//     setPopupMessage(message);
//     setPopupVisible(true);
//   };

//   const closePopup = () => {
//     setPopupVisible(false);
//   };
//   const handleDelete = (contractId) => {
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(false);
//     setContractToDelete(contractId);
//     setConfirmDeleteVisible(true);
//   };

//   const handleBulkDelete = () => {
//     if (!selectedinvoices || selectedinvoices.length === 0) {
//       showPopup("Error", "Please select at least one contract to delete.");
//       return;
//     }
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(true);
//     setConfirmDeleteVisible(true);
//   };

//   const handleEditSave = async (invoiceId, invoiceKey) => {
//     const customFieldsData = editedContractData.details?._custom_fields || {};

//     const formattedAmount = editedContractData.details?.["Currency"]
//       ? `${editedContractData.details["Currency"]}${editedContractData.details["Total due amount"]}`
//       : editedContractData.details?.["Total due amount"];

//     const editedData = {
//       "Issued on": editedContractData.details?.["Issued on"],
//       "Customer name": editedContractData.details?.["Customer name"],
//       "Vendor name": editedContractData.details?.["Vendor name"],
//       "Total due amount": formattedAmount,
//       "Due date": editedContractData.details?.["Due date"],
//       _custom_fields: customFieldsData,
//     };

//     const note = "Updated invoice details";
//     const invoice_name_payload = invoice_name;
//     try {
//       const response = await api.post(
//         `api/v1/invoice/edit-invoice-details/${invoiceKey}/`,
//         {
//           edited_data: editedData,
//           note,
//           invoice_name: invoice_name_payload,
//         }
//       );

//       if (response.status === 200) {
//         const updatedInvoice = response.data.data;

//         setinvoices((prevInvoices) =>
//           prevInvoices.map((invoice) =>
//             invoice.id === invoiceId
//               ? { ...invoice, name: invoice_name, details: updatedInvoice }
//               : invoice
//           )
//         );

//         setEditContractId(null);
//         setRenameSuccessRowId(invoiceId); // Show success message only for that row

//         setTimeout(() => setRenameSuccessRowId(null), 3000);
//       }
//     } catch (error) {
//       console.error("Error saving invoice:", error);
//       showPopup("Error", "Failed to update invoice. Please try again.");
//     }
//   };

//   const confirmDelete = async () => {
//     const idsToDelete = isBulkDelete ? selectedinvoices : [contractToDelete];

//     setDeleteInProgress(true);

//     try {
//       const response = await api.delete(`api/v1/invoice/delete-invoice/`, {
//         data: { invoice_ids: idsToDelete },
//       });

//       const { Deleted_invoices = [], Failed_deletions = [] } = response.data;

//       if (Deleted_invoices.length > 0) {
//         setinvoices((previnvoices) =>
//           previnvoices.filter(
//             (invoice) => !Deleted_invoices.includes(invoice.id)
//           )
//         );

//         if (isBulkDelete) {
//           setSelectedinvoices([]);
//           setSelectedContractKeys([]);
//         }
//       }

//       if (Failed_deletions.length > 0) {
//         const failureMessages = Failed_deletions.map(
//           (failure) => `Invoice ID ${failure.invoice_id}: ${failure.error}`
//         ).join("\n");
//         showPopup("Deletion Failed", failureMessages);
//       }
//     } catch (error) {
//       console.error("Error deleting invoices:", error);
//       showPopup("Error", "Failed to delete invoice(s). Please try again.");
//     } finally {
//       setDeleteInProgress(false);
//       setConfirmDeleteVisible(false); // 👈 Close modal
//       setIsBulkDelete(false); // 👈 Reset bulk delete flag
//       setContractToDelete(null); // 👈 Clear single delete state
//       fetchinvoices();
//     }
//   };

//   useEffect(() => {
//     if (editContractId) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [editContractId]);
//   const [isTooltipVisible, setIsTooltipVisible] = useState(false);

//   return (
//     <>
//       {loading && <Spinner />}
//       <div className="full-container max-w-full overflow-x-hidden">
//         <div className="">
//           <Header name="Invoices" icon={""} isMenuOpen={isMenuOpen} />
//         </div>

//         <div
//           className="contract-table-container relative overflow-x-hidden"
//           style={{ marginLeft: isMenuOpen ? "226px" : "120px" }}
//         >
//           <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[3px]">
//             {/* LEFT: Search & Filter */}
//             <div className="flex items-center gap-1 min-w-[300px]">
//               {/* Search */}
//               <div
//                 style={{
//                   display: "flex",
//                   width: "310px",
//                   height: "40px",
//                   padding: "8px 20px 8px 26px",
//                   alignItems: "center",
//                   gap: "1px",
//                   flexShrink: 0,
//                   borderRadius: "20px",
//                   border: isSearchFocused
//                     ? "1px solid rgba(187, 66, 174, 0.36)"
//                     : "1px solid rgba(0, 0, 0, 0.10)",
//                   backgroundColor: "#FFF",
//                   boxShadow: isSearchFocused
//                     ? "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)"
//                     : "none",
//                   overflow: "hidden",
//                   transition: "all 0.3s ease-in-out",
//                 }}
//               >
//                 <img
//                   src="search.svg"
//                   alt="Search"
//                   style={{ width: "24px", height: "24px", marginRight: "4px" }}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Search Invoices Here"
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   onFocus={() => setIsSearchFocused(true)}
//                   onBlur={() => setIsSearchFocused(false)}
//                   style={{
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "14px",
//                     fontWeight: 400,
//                     border: "none",
//                     outline: "none",
//                     width: "100%",
//                     overflowX: "auto",
//                     whiteSpace: "nowrap",
//                     color: "#171717",
//                   }}
//                 />
//               </div>

//               {/* Filter */}
//               <button
//                 className={`filter-button-new ${
//                   isFilterApplied ? "filter-applieds" : ""
//                 }`}
//                 onClick={toggleFilterModal}
//               >
//                 <img
//                   src={isFilterApplied ? "/Filter_CTA.png" : "/filter.svg"}
//                   alt="Filter Icon"
//                 />
//               </button>
//             </div>

//             {/* RIGHT SIDE */}
//             <div className="flex items-center gap-3 flex-wrap justify-end">
//               {selectedinvoices.length > 0 ? (
//                 <>
//                   <span className="bg-[#F4EBFF] text-[#7F56D9] text-sm px-3 py-1 rounded-full font-medium">
//                     {selectedinvoices.length} Invoice selected
//                   </span>

//                   <button
//                     className="bg-[#7F56D9] text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-[#6941C6] transition"
//                     onClick={() => setIsCustomApplyFiledModal(true)}
//                   >
//                     <span className="text-white">Apply Custom Field</span>
//                   </button>

//                   {/* More Dropdown */}
//                   <div className="relative">
//                     <button
//                       ref={moreButtonRef}
//                       onClick={handleToggleMore}
//                       className="border border-[#D0D5DD] text-[#344054] text-sm font-medium px-4 py-2 rounded-md flex items-center gap-2 hover:bg-gray-50"
//                     >
//                       More
//                       <svg
//                         className="w-4 h-4"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth={2}
//                         viewBox="0 0 24 24"
//                       >
//                         <path d="M19 9l-7 7-7-7" />
//                       </svg>
//                     </button>

//                     {isActionMenuOpen === "more" && (
//                       <div
//                         className="fixed z-[9999] w-30 bg-white border border-gray-200 rounded-md shadow-lg p-2"
//                         style={{
//                           top: `${dropdownCoords.top}px`,
//                           left: `${dropdownCoords.left}px`,
//                         }}
//                       >
//                         {/* Export */}
//                         <button
//                           onClick={handleExport}
//                           disabled={exportInProgress}
//                           className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-purple-100 text-[#8B55DD] disabled:opacity-50"
//                         >
//                           <img
//                             src="./export-icon-blue.svg"
//                             alt="Export Icon"
//                             className="w-4 h-4"
//                           />
//                           {exportInProgress ? "Exporting..." : "Export"}
//                         </button>

//                         {/* Delete */}
//                         <button
//                           onClick={handleBulkDelete}
//                           className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-red-100 text-red-600"
//                         >
//                           <img
//                             src="./delete-icon-red.svg"
//                             alt="Delete Icon"
//                             className="w-4 h-4"
//                           />
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </div>

//                   <button onClick={handleCancel} className="ml-2">
//                     <img
//                       src="/cancel_icon.svg"
//                       alt="Cancel Icon"
//                       className="w-5 h-5"
//                     />
//                   </button>
//                 </>
//               ) : (
//                 <>
//                   <button
//                     className="flex items-center gap-2 px-4 py-2 bg-white new-custom-butons-design"
//                     onClick={() => setIsCustomFieldModalOpen(true)}
//                   >
//                     <img src="/custom-field-icons.svg" className="w-5 h-5" />
//                     <span className="new-custom-butons-design-text">
//                       Custom Field
//                     </span>
//                   </button>

//                   {/* Upload with Tooltip */}
//                    <div className="relative">
//                    <button
//                      ref={uploadButtonRef}
//                      className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
//                      onClick={() => setIsTooltipVisible(!isTooltipVisible)}
//                      onMouseEnter={() => {
//                        if (uploadButtonRef.current) {
//                          const rect = uploadButtonRef.current.getBoundingClientRect();
//                          setTooltipCoords({
//                            top: rect.top + window.scrollY + 45,
//                            left: rect.left + window.scrollX + rect.width - 140,
//                          });
//                        }
//                      }}
//                    >
//                      <img src="/upload_icon_white.svg" className="w-5 h-5" />
//                      <span className="new-custom-butons-design-texts">Upload Invoice</span>
//                    </button>
                 
                 
//                            {/* Tooltip */}
//                          {isTooltipVisible && (
//                            <div
//                              className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
//                              style={{
//                                top: `${tooltipCoords.top + 10}px`,
//                                left: `${tooltipCoords.left - 50}px`,
//                              }}
//                              onMouseLeave={() => setIsTooltipVisible(false)}
//                            >
//                              {/* Upload from Device */}
//                              <div
//                                className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                                onClick={() => {
//                                  setIsTooltipVisible(false);
//                                  fileInputRef.current.click();
//                                }}
//                              >
//                                <img src="/upload-icon.svg" alt="Upload" className="w-4 h-4" />
//                                Add from device
//                              </div>
                         
//                              {/* Connect Google Drive */}
//                              {!isConnected && (
//                                <div
//                                  className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                                  onClick={() => {
//                                    setIsTooltipVisible(false);
//                                    navigate("/account/integration");
//                                  }}
//                                  onMouseEnter={() => setIsHovered(true)}
//                              onMouseLeave={() => setIsHovered(false)}
//                                >
//                           <img
//                                src={isHovered ? "/connect-icon-hover.svg" : "/connect-icon.svg"}
//                                alt="Open Picker"
//                                className="w-4 h-4 transition-all duration-150"
//                              />        Connect Drive
//                                </div>
//                              )}
                         
//                             {isConnected && (
//   <div
//     className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//     onMouseEnter={() => setIsHovered(true)}
//     onMouseLeave={() => setIsHovered(false)}
//     onClick={handleAddFromDriveClick} // Trigger the picker on click
//   >
//     <img
//       src={isHovered ? "/picker-icon-hover.svg" : "/picker-icon.svg"}
//       alt="Open Picker"
//       className="w-4 h-4 transition-all duration-150"
//     />
//     Add from Drive
//   </div>
// )}
//                            </div>
//                          )}

//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       multiple
//                       className="hidden"
//                       accept=".pdf,.xls,.xlsx,.csv,.txt,.doc,.jpeg,.jpg,.png,.webp,.bmp"
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           <div
//             className={`overflow-x-auto  transition-all duration-300 mt-2`}
//             style={{
//               width: isMenuOpen ? "calc(100vw - 320px)" : "calc(100vw - 158px)",
//             }}
//           >
//             <div className="overflow-x-auto w-[100%]  mb-4">
//               <div
//                 className="relative overflow-x-auto  custom-scrollbar-container"
//                 style={{
//                   height: "calc(100vh - 180px)", // Adjust height as needed
//                 }}
//                 ref={tbodyRef}
//               >
//                 <table
//                   className="text-sm text-left table-auto"
//                   style={{ minWidth: `${totalColumns * 14.29}%` }}
//                 >
//                   <thead className="bg-[#FFF] h-[51px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
//                     <tr>
//                       <th className="w-[40px] px-3">
//                         <input
//                           type="checkbox"
//                           className="custom-checkbox"
//                           style={{
//                             appearance: "none",
//                             // width: "16px",
//                             // height: "16px",
//                             border: "1.5px solid #c0c0c0",
//                             borderRadius: "4px",
//                             cursor: "pointer",
//                             backgroundImage:
//                               selectedinvoices.length === invoices.length &&
//                               invoices.length > 0
//                                 ? "url('/checck.svg')"
//                                 : "none",
//                             backgroundPosition: "center",
//                             backgroundRepeat: "no-repeat",
//                             backgroundSize: "20px 20px",
//                           }}
//                           onChange={handleSelectAll}
//                           checked={
//                             selectedinvoices.length === invoices.length &&
//                             invoices.length > 0
//                           }
//                         />
//                       </th>

//                       <th className="min-w-[130px] px-1 file-size-of-heading">
//                         Invoice Name
//                       </th>
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Customer Name
//                       </th>
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Vendor Name
//                       </th>

//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Amount
//                       </th>
//                       {customFields.map((field, index) => (
//                         <th
//                           key={index}
//                           className="min-w-[120px] px-3 file-size-of-headings"
//                         >
//                           <span className="inline-flex items-baseline gap-1">
//                             {field.field}{" "}
//                             <img
//                               src="/invoice-bulblogo-invoicee.svg"
//                               alt="Bullet Icon"
//                               className="ml-1 translate-y-[-2px]" // slightly lifted
//                             />
//                           </span>
//                         </th>
//                       ))}
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Date Issued
//                       </th>
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Due Date
//                       </th>
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Actions
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody
//                     className={
//                       currentinvoices.length > rowsPerPage ? "scrollable" : ""
//                     }
//                     style={{
//                       overflowY:
//                         currentinvoices.length > rowsPerPage
//                           ? "auto"
//                           : "hidden",
//                       maxHeight: "400px",
//                       backgroundColor: "#FFF",
//                     }}
//                   >
//                     {loading ? (
//                       <tr>
//                         <td colSpan="6" style={{ textAlign: "center" }}>
//                           <Spinner />
//                         </td>
//                       </tr>
//                     ) : invoices.length > 0 ? (
//                       currentinvoices.map((contract, index) => (
//                         <tr
//                           key={index}
//                           ref={
//                             editContractId === contract.id ? editRowRef : null
//                           }
//                           style={{
//                             background:
//                               hoveredRow === index ? "#F8F3FF" : "transparent",
//                             boxShadow:
//                               hoveredRow === index
//                                 ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25)"
//                                 : "none",
//                           }}
//                           onMouseEnter={() => setHoveredRow(index)}
//                           onMouseLeave={() => setHoveredRow(null)}
//                           className="h-[44px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
//                         >
//                           <td className="px-3">
//                             <input
//                               type="checkbox"
//                               className="custom-checkbox"
//                               style={{
//                                 appearance: "none",
//                                 // width: "16px",
//                                 // height: "16px",
//                                 border: "1.5px solid #c0c0c0",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                                 backgroundImage: selectedinvoices.includes(
//                                   contract.id
//                                 )
//                                   ? "url('/checck.svg')"
//                                   : "none",
//                                 backgroundPosition: "center",
//                                 backgroundRepeat: "no-repeat",
//                                 backgroundSize: "20px 20px",
//                               }}
//                               checked={selectedinvoices.includes(contract.id)}
//                               onChange={() =>
//                                 handleCheckboxChange(contract.id, contract.key)
//                               }
//                             />
//                           </td>

//                           {editContractId === contract.id ? (
//                             <>
//                               <td>
//                                 <input
//                                   type="text"
//                                   value={invoice_name}
//                                   onChange={(e) =>
//                                     setInvoiceName(e.target.value)
//                                   }
//                                   className="edit-contract-name"
//                                   placeholder="Enter Invoice Name"
//                                 />
//                               </td>

//                               <td>
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Customer name"
//                                     ] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Customer name",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name"
//                                 />
//                               </td>
//                               <td>
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Vendor name"
//                                     ] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Vendor name",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name"
//                                 />
//                               </td>
//                               <td>
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.["Currency"]
//                                       ? `${editedContractData.details["Currency"]} ${editedContractData.details["Total due amount"]}`
//                                       : editedContractData.details?.[
//                                           "Total due amount"
//                                         ] || ""
//                                   }
//                                   onChange={(e) => {
//                                     const rawValue = e.target.value.replace(
//                                       /[^0-9.,]/g,
//                                       ""
//                                     );
//                                     handleEditChange(
//                                       "details.Total due amount",
//                                       rawValue
//                                     );
//                                   }}
//                                   className="edit-contract"
//                                 />
//                               </td>
//                               {customFields.map((fieldObj, index) => {
//                                 const fieldKey = fieldObj.field;
//                                 return (
//                                   <td
//                                     key={index}
//                                     className="file-size-of-subheading"
//                                   >
//                                     <input
//                                       type="text"
//                                       value={
//                                         editedContractData.details
//                                           ?._custom_fields?.[fieldKey] || ""
//                                       }
//                                       onChange={(e) =>
//                                         handleEditChange(
//                                           `details._custom_fields.${fieldKey}`,
//                                           e.target.value
//                                         )
//                                       }
//                                       className="edit-contract"
//                                     />
//                                   </td>
//                                 );
//                               })}
//                               <td>
//                                 <input
//                                   type="date"
//                                   value={
//                                     editedContractData.details?.["Issued on"] ||
//                                     ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Issued on",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract"
//                                 />
//                               </td>
//                               <td>
//                                 <input
//                                   type="date"
//                                   value={
//                                     editedContractData.details?.["Due date"] ||
//                                     ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Due date",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract"
//                                 />
//                               </td>
//                               <td className="action-icons-contract">
//                                 <button
//                                   onClick={() =>
//                                     handleEditSave(contract.id, contract.key)
//                                   }
//                                   className="icon-button-contract"
//                                 >
//                                   <img
//                                     src="/save-icon-contracttable.svg"
//                                     alt="Save"
//                                     className="action-icon"
//                                   />
//                                 </button>
//                                 <button
//                                   onClick={() => setEditContractId(null)}
//                                   className="icon-button-contract"
//                                 >
//                                   <img
//                                     src="/cancel-icon-contracttable.svg"
//                                     alt="Cancel"
//                                     className="action-icon"
//                                   />
//                                 </button>
//                               </td>
//                             </>
//                           ) : (
//                             <>
//                               <td className="px-1 file-size-of-subheading">
//                                 <span
//                                   className="tooltip-wrapper"
//                                   style={{
//                                     color: "#B793ED",
//                                     textDecoration: "underline",
//                                     cursor: "pointer",
//                                   }}
//                                   onClick={() =>
//                                     navigate(
//                                       `/Invoices/Invoice_Details/${contract.key}`
//                                     )
//                                   }
//                                 >
//                                   {contract.name?.length > 25
//                                     ? `${contract.name.slice(
//                                         0,
//                                         40
//                                       )}...${contract.name.slice(-5)}`
//                                     : contract.name || "N/A"}
//                                   <span className="tooltip-text">
//                                     {contract.name || "N/A"}
//                                   </span>
//                                   {renameSuccessRowId === contract.id && (
//                                     <div
//                                       className="inline-flex p-2"
//                                       style={{
//                                         width: "205px",
//                                         height: "32px",
//                                         borderRadius: "8px",
//                                         border: "1px solid rgba(0, 0, 0, 0.10)",
//                                         background: "#FFF",
//                                         boxShadow:
//                                           "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)",
//                                         position: "absolute",
//                                         marginLeft: "4rem",
//                                         zIndex: 10,
//                                       }}
//                                     >
//                                       <img
//                                         src="/green-icon-tick.svg"
//                                         alt="Success"
//                                         style={{
//                                           width: "20px",
//                                           height: "20px",
//                                         }}
//                                       />
//                                       <span
//                                         style={{
//                                           color: "#52525B",
//                                           fontFamily: "Outfit",
//                                           fontSize: "13px",
//                                           fontStyle: "normal",
//                                           fontWeight: 400,
//                                           letterSpacing: "-0.26px",
//                                         }}
//                                       >
//                                         Your changes were applied
//                                       </span>
//                                     </div>
//                                   )}
//                                 </span>
//                               </td>

//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Customer name"] || "N/A"}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Vendor name"] || "N/A"}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Total due amount"] ||
//                                   "N/A"}
//                               </td>
//                               {customFields.map((fieldObj, index) => {
//                                 const fieldKey = fieldObj.field; // actual key used in _custom_fields
//                                 const fieldValue =
//                                   contract.details?._custom_fields?.[
//                                     fieldKey
//                                   ] || "N/A";
//                                 const isValid =
//                                   fieldValue && fieldValue !== "null";

//                                 return (
//                                   <td
//                                     key={index}
//                                     className="px-3 file-size-of-subheadin"
//                                   >
//                                     <span
//                                       className="text-[#B793ED] cursor-pointer inline-block max-w-[140px] truncate"
//                                       onMouseEnter={(e) => {
//                                         const rect =
//                                           e.currentTarget.getBoundingClientRect();
//                                         setCustomFieldPopup({
//                                           visible: true,
//                                           value: fieldValue,
//                                           contractKey: contract.key,
//                                           contractId: contract.id,
//                                           x: rect.left + window.scrollX,
//                                           y: rect.bottom + window.scrollY + 8,
//                                         });
//                                       }}
//                                       onMouseLeave={(e) => {
//                                         // Start timeout that allows user to move to popup
//                                         setTimeout(() => {
//                                           if (
//                                             popupRef.current &&
//                                             !popupRef.current.matches(":hover")
//                                           ) {
//                                             setCustomFieldPopup((prev) => ({
//                                               ...prev,
//                                               visible: false,
//                                             }));
//                                           }
//                                         }, 150);
//                                       }}
//                                     >
//                                       {fieldValue.length > 10
//                                         ? `${fieldValue.slice(0, 10)}...`
//                                         : fieldValue}
//                                     </span>
//                                   </td>
//                                 );
//                               })}
//                               <td className="px-3 file-size-of-subheading">
//                                 {formatDates(contract.details?.["Issued on"])}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {formatDates(contract.details?.["Due date"])}
//                               </td>

//                               <td className="px-3 ">
//                                 <img
//                                   src="./action.svg"
//                                   alt="Actions"
//                                   width="20"
//                                   height="20"
//                                   onClick={(e) => toggleActionMenu(index, e)}
//                                   style={{ cursor: "pointer" }}
//                                 />
//                                 {isActionMenuOpen === index && (
//                                   <div
//                                     className="action-menu"
//                                     style={{
//                                       position: "fixed",
//                                       top: actionMenuPosition.openUpwards
//                                         ? `${actionMenuPosition.top}px`
//                                         : `${actionMenuPosition.top}px`,
//                                       left: `${
//                                         actionMenuPosition.left - 215
//                                       }px`,
//                                       transform: actionMenuPosition.openUpwards
//                                         ? "translateY(50%)"
//                                         : "none", // If openUpwards, shift the menu upward
//                                       zIndex: 9999,
//                                     }}
//                                     ref={actionMenuRef}
//                                   >
//                                     <div
//                                       className="action-item"
//                                       onMouseEnter={() =>
//                                         setHoveredAction("edit")
//                                       }
//                                       onMouseLeave={() =>
//                                         setHoveredAction(null)
//                                       }
//                                       onMouseDown={() =>
//                                         setClickedAction("edit")
//                                       }
//                                       onMouseUp={() => setClickedAction(null)}
//                                       onClick={() => enableEdit(contract)}
//                                       style={{
//                                         color:
//                                           clickedAction === "edit"
//                                             ? "#C95EBE"
//                                             : hoveredAction === "edit"
//                                             ? "#C95EBE"
//                                             : "#000",
//                                         transition:
//                                           "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                                         borderRadius: "8px",
//                                         border:
//                                           clickedAction === "edit" ||
//                                           hoveredAction === "edit"
//                                             ? "none"
//                                             : "none",
//                                         background:
//                                           clickedAction === "edit" ||
//                                           hoveredAction === "edit"
//                                             ? "#FAF9F6"
//                                             : "transparent",
//                                         padding: "10px",
//                                         cursor: "pointer",
//                                         width: "8.2rem",
//                                       }}
//                                     >
//                                       <img
//                                         src={
//                                           clickedAction === "edit"
//                                             ? "./edit-active-contract.svg"
//                                             : hoveredAction === "edit"
//                                             ? "./edit-active-contract.svg"
//                                             : "./edit.svg"
//                                         }
//                                         alt="Edit Icon"
//                                         className="action-icon"
//                                       />
//                                       <p>Edit</p>
//                                     </div>

//                                     <div
//                                       className="action-item"
//                                       onMouseEnter={() =>
//                                         setHoveredAction("delete")
//                                       }
//                                       onMouseLeave={() =>
//                                         setHoveredAction(null)
//                                       }
//                                       onMouseDown={() =>
//                                         setClickedAction("delete")
//                                       }
//                                       onMouseUp={() => setClickedAction(null)}
//                                       onClick={() => handleDelete(contract.id)}
//                                       style={{
//                                         color:
//                                           clickedAction === "delete"
//                                             ? "rgba(226, 25, 25, 0.75)"
//                                             : hoveredAction === "delete"
//                                             ? "rgba(226, 25, 25, 0.75)"
//                                             : "#000",
//                                         transition:
//                                           "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                                         borderRadius: "8px",
//                                         border:
//                                           clickedAction === "delete" ||
//                                           hoveredAction === "delete"
//                                             ? "none"
//                                             : "none",
//                                         background:
//                                           clickedAction === "delete" ||
//                                           hoveredAction === "delete"
//                                             ? "#FAF9F6"
//                                             : "transparent",
//                                         padding: "10px",
//                                         cursor: "pointer",
//                                         width: "8.2rem",
//                                       }}
//                                     >
//                                       <img
//                                         src={
//                                           clickedAction === "delete"
//                                             ? "./delete-active-contract.svg"
//                                             : hoveredAction === "delete"
//                                             ? "./delete-active-contract.svg"
//                                             : "./delete.svg"
//                                         }
//                                         alt="Delete Icon"
//                                         className="action-icon"
//                                       />
//                                       <p>Delete</p>
//                                     </div>
//                                   </div>
//                                 )}
//                               </td>
//                             </>
//                           )}
//                         </tr>
//                       ))
//                     ) : (
//                       <tr className="h-[44px] text-center">
//                         <td colSpan="7" className="py-6 text-black-400">
//                           <img
//                             src="/no-contracts.svg"
//                             alt="No Data"
//                             className="mx-auto mb-2"
//                           />
//                           <p className="text-[16px]">
//                             Looks like your table is empty!
//                           </p>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               {invoices.length > 0 && (
//                 <div className="pagination-doc">
//                   <div className="pagination-dropdown">
//                     <p className="page-selector">{currentPage}</p>
//                   </div>
//                   <p className="contentDown">of {totalPages} pages</p>
//                   <button
//                     onClick={handlePreviousPage}
//                     disabled={currentPage === 1}
//                     style={{
//                       cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="decrease.svg"
//                       alt="Previous Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                   <button
//                     onClick={handleNextPage}
//                     disabled={currentPage === totalPages}
//                     style={{
//                       cursor:
//                         currentPage === totalPages ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="increase.svg"
//                       alt="Next Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {popupVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box">
//               <h2>{popupTitle}</h2>
//               <p>{popupMessage}</p>
//               <button onClick={closePopup} className="popup-close-button">
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {confirmDeleteVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box-delete">
//               <h2>Are you sure you want to delete the selected spreadsheet?</h2>
//               <p>
//                 {isBulkDelete
//                   ? "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."
//                   : "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."}
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "8px",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                 }}
//               >
//                 <button
//                   onClick={() => setConfirmDeleteVisible(false)}
//                   disabled={deleteInProgress}
//                   className="document-popup-close-delete"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   disabled={deleteInProgress}
//                   className="document-popup-close-button"
//                 >
//                   {deleteInProgress ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {console.log("UploadModal file prop:", file)}

//         <UploadModal
//           isOpen={isModalOpen}
//           onClose={handleCloseModal}
//           onUploadSuccess={handleUploadSuccess}
//           type={"Invoices"}
//           file={file}
//         />

//         <FilterModal
//           isOpen={isFilterModalOpen}
//           onClose={() => setIsFilterModalOpen(false)}
//           token={token}
//           setInvoices={(filteredInvoices) => {
//             setinvoices(filteredInvoices);
//             setIsFilterApplied(true);
//             setIsFilterModalOpen(false);
//           }}
//           isInvoice={true}
//           fetchinvoices={fetchinvoices}
//           setIsFilterApplied={setIsFilterApplied}
//         />
//         {isCustomApplyFieldModal && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
//             <div
//               className="relative bg-white rounded-[12px] shadow-lg w-[417px] h-[366px] pt-[18px] pl-[24px] pr-[24px] pb-[24px]"
//               style={{
//                 boxShadow:
//                   "130px 189px 64px rgba(0, 0, 0, 0.00), 83px 121px 59px rgba(0, 0, 0, 0.01), 47px 68px 50px rgba(0, 0, 0, 0.05), 21px 30px 37px rgba(0, 0, 0, 0.09), 5px 8px 20px rgba(0, 0, 0, 0.10)",
//               }}
//             >
//               <div className="flex justify-between items-center">
//                 <h2 className="apply-heading-cutom">Apply Custom Field</h2>
//                 <span className="text-[#8B55DD] bg-[rgba(139,85,221,0.08)] text-[14px] rounded px-3 py-1">
//                   {selectedinvoices.length} Contracts selected
//                 </span>
//                 <span
//                   onClick={() => setIsCustomApplyFiledModal(false)}
//                   className="cursor-pointer text-xl"
//                 >
//                   ×
//                 </span>
//               </div>

//               <div className="flex gap-8 mt-[20px] items-start">
//                 {/* Option 1: Select Existing */}
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input
//                     type="radio"
//                     checked={!isCreatingNew}
//                     onChange={() => setIsCreatingNew(false)}
//                     className="accent-[#7F56D9] w-4 h-4"
//                   />
//                   <span className="apply-dot-heading">
//                     Select from Existing Field
//                   </span>
//                 </label>

//                 {/* Option 2: Create New Field + (2/5 used) below it */}
//                 <label className="flex flex-col cursor-pointer">
//                   <div className="flex items-center gap-2">
//                     <input
//                       type="radio"
//                       checked={isCreatingNew}
//                       onChange={() => setIsCreatingNew(true)}
//                       className="accent-[#7F56D9] w-4 h-4"
//                     />
//                     <span className="apply-dot-heading">Create New Field</span>
//                   </div>
//                   <span className="text-xs text-[#999] ml-6">
//                     ({customFields.length}/5 used)
//                   </span>
//                 </label>
//               </div>

//               {isCreatingNew ? (
//                 <>
//                   <label className="apply-dot-heading">Field Name</label>
//                   <input
//                     className="apply-input-field pl-2 mt-1"
//                     placeholder="Enter your field name here"
//                     value={newFieldName}
//                     onChange={(e) => setNewFieldName(e.target.value)}
//                   />
//                   <label className="apply-dot-heading mt-2">
//                     Extraction Prompt
//                   </label>
//                   <textarea
//                     className="apply-input-field-design-here pl-2 pt-1 pr-1 mt-1"
//                     placeholder="Enter your Extraction Prompts here"
//                     value={newPrompt}
//                     onChange={(e) => setNewPrompt(e.target.value)}
//                   />
//                 </>
//               ) : (
//                 <>
//                   <label className="apply-dot-heading">Choose Field</label>
//                   <CustomDropdown
//                     selected={selectedField}
//                     onSelect={setSelectedField}
//                     options={customFields.map((field) => field.field)}
//                   />
//                 </>
//               )}

//               <div className="absolute bottom-4 right-4 flex justify-end gap-3">
//                 <button
//                   className="cancel-apply-button-design"
//                   onClick={() => setIsCustomApplyFiledModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleApplyField}
//                   className={`apply-apply-button ${
//                     isLoading
//                       ? "bg-[#D081D9]"
//                       : "bg-[#D081D9] hover:bg-[#C26ED2]"
//                   }`}
//                 >
//                   {isLoading ? (
//                     <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                   ) : isCreatingNew ? (
//                     "Create & Apply"
//                   ) : (
//                     "Apply Field"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {isCustomFieldModalOpen && (
//           <div className="custom-modal-overlay-inline show">
//             <div className="custom-modal-content-custom active relative">
//               <button
//                 className="close-modal-custom"
//                 onClick={() => setIsCustomFieldModalOpen(false)}
//               >
//                 ×
//               </button>

//               <h2 className="custom-modal-title-custom">Custom Fields</h2>
//               <p className="custom-modal-subtitle-custom">
//                 You can only create up to 5 custom fields per document.
//                 <br />
//                 Deleting a field won’t reset the limit.
//               </p>

//               <div className="custom-modal-tabs-custom">
//                 <button
//                   className={`manage-btn-custom ${
//                     selectedTab === "manage" ? "active" : ""
//                   }`}
//                   onClick={() => setSelectedTab("manage")}
//                 >
//                   {customFieldsLoading
//                     ? "Loading..."
//                     : `Manage Existing Fields (${customFields.length}/5)`}
//                 </button>
//                 <button
//                   className={`create-btn-custom ${
//                     selectedTab === "create" ? "active" : ""
//                   }`}
//                   onClick={() => setSelectedTab("create")}
//                 >
//                   Create New Field
//                 </button>
//               </div>

//               {selectedTab === "create" && (
//                 <>
//                   <label className="field-label-custom">
//                     Field name{" "}
//                     <img
//                       src="/bulb.svg"
//                       alt="Hint"
//                       className="label-icon-custom"
//                     />
//                   </label>
//                   <input
//                     type="text"
//                     className="input-field-custom"
//                     value={fieldName}
//                     onChange={(e) => setFieldName(e.target.value)}
//                     placeholder={
//                       isMaxFieldsReached
//                         ? "Maximum 5 fields allowed. Please delete one to add new."
//                         : "Enter your field name here"
//                     }
//                     disabled={isMaxFieldsReached}
//                   />
//                   <label className="field-label-custom">
//                     Extraction Prompt{" "}
//                     <img
//                       src="/bulb.svg"
//                       alt="Hint"
//                       className="label-icon-custom"
//                     />
//                   </label>
//                   <textarea
//                     className="textarea-field-custom"
//                     value={fieldPrompt}
//                     onChange={(e) => setFieldPrompt(e.target.value)}
//                     placeholder={
//                       isMaxFieldsReached
//                         ? "Cannot enter prompt. Maximum limit reached."
//                         : "Enter your Extraction Prompts here"
//                     }
//                     disabled={isMaxFieldsReached}
//                   />
//                   <button
//                     className={`add-field-btn-custom ${
//                       isFilled && !loadingAddField && !isMaxFieldsReached
//                         ? "active"
//                         : ""
//                     }`}
//                     onClick={handleAddField}
//                     disabled={loadingAddField || isMaxFieldsReached}
//                   >
//                     {loadingAddField ? "Adding..." : "Add Field"}
//                   </button>
//                 </>
//               )}

//               {selectedTab === "manage" && (
//                 <div>
//                   <div className="manage-fields-placeholder mt-[20px] max-h-[222px] overflow-y-auto mr-2">
//                     <div className="flex mt-2 gap-[60px]">
//                       <h2 className="field-name-custom">Field Name</h2>
//                       <h2 className="field-name-custom">Prompt</h2>
//                     </div>
//                     {customFields.length ? (
//                       customFields.map((field, index) => (
//                         <div key={index}>
//                           <div className="flex items-start gap-[26px] mt-[12px]">
//                             <p className="text-[#1A1A1A] text-sm font-medium w-[100px] break-words">
//                               {field.field}
//                             </p>
//                             <p className="text-[#1A1A1A] text-sm w-[139px]">
//                               {field.description}
//                             </p>
//                             <button
//                               className="button-red-custom-field"
//                               onClick={() => {
//                                 setDeletingField(field.id);
//                                 handleDeleteField(field.id);
//                               }}
//                               disabled={deletingField === field.id}
//                             >
//                               {deletingField === field.id
//                                 ? "Deleting"
//                                 : "Delete"}
//                               <img src="/delete-icon-red.svg" alt="Delete" />
//                             </button>
//                           </div>
//                           <div className="my-4 mt-[20px] border-[#EAEAEA] hr-line-divider"></div>
//                         </div>
//                       ))
//                     ) : (
//                       <p className="text-sm text-gray-500 ml-2 mt-3">
//                         No custom fields available.
//                       </p>
//                     )}
//                   </div>

//                   <button
//                     className="add-field-btn-custom-twos absolute bottom-4 right-4"
//                     onClick={async () => {
//                       await fetchinvoices(); // refresh table to show new field
//                       setIsCustomFieldModalOpen(false);
//                     }}
//                   >
//                     Done
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//         {customFieldPopup.visible && (
//           <div
//             ref={popupRef}
//             className="fixed z-[9999] bg-white border border-gray-300 rounded-md shadow-md p-3"
//             style={{
//               top: `${customFieldPopup.y}px`,
//               left: `${customFieldPopup.x}px`,
//               maxWidth: "300px",
//               width: "max-content",
//               whiteSpace: "normal",
//             }}
//             onMouseEnter={() =>
//               setCustomFieldPopup((prev) => ({ ...prev, visible: true }))
//             }
//             onMouseLeave={() =>
//               setCustomFieldPopup((prev) => ({ ...prev, visible: false }))
//             }
//           >
//             <p className="text-gray-800 text-sm font-medium break-words">
//               {customFieldPopup.value.length > 40
//                 ? `${customFieldPopup.value.slice(0, 40)}...`
//                 : customFieldPopup.value}
//             </p>
//             <button
//               onClick={() =>
//                 handleViewMore(
//                   customFieldPopup.contractKey,
//                   customFieldPopup.contractId
//                 )
//               }
//               className="text-[#6F42C1] text-sm font-semibold underline mt-2 hover:text-[#4c2a8a]"
//             >
//               View More
//             </button>
//           </div>
//         )}

//         {fieldCreationSuccess && (
//           <div
//             className="success-popup inline-flex items-center p-4 bg-white border border-gray-200 shadow-sm rounded-md text-sm text-gray-700 fixed z-[100]"
//             style={{
//               top: "50%",
//               left: "50%",
//               transform: "translate(-50%, -50%)",
//             }}
//           >
//             <img src="/green-icon-tick.svg" className="mr-2" alt="Success" />
//             Field Created successfully, Select documents to apply this field
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default ContractTable;
/* global google */
/* global gapi */
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import Cookies from "js-cookie";
import { toast } from "../../utils/appToast";
import api from "../chat/api";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import UploadModal from "../Contract/UploadModal";
import FilterModal from "../Contract/filterModal";
import CustomDropdown from "../Contract/CustomDropdown";
import useGooglePicker from "../Ocr_Data/useGooglePicker";

const ContractTable = ({ isMenuOpen }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [invoices, setinvoices] = useState([]);
  const [token, setToken] = useState(null);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const [loading, setLoading] = useState(true);
  const editRowRef = useRef(null);
  const [selectedinvoices, setSelectedinvoices] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const actionMenuRef = useRef(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [timeRange, setTimeRange] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [invoice_name, setInvoiceName] = useState("");
  const [actionMenuPosition, setActionMenuPosition] = useState({
    top: 0,
    left: 0,
    openUpwards: false,
  });

  const { isConnected, openPicker, accessToken } = useGooglePicker();
  const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
  const [isCustomApplyFieldModal, setIsCustomApplyFiledModal] = useState(false);
  const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
  const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("manage");
  const [fieldName, setFieldName] = useState("");
  const [fieldPrompt, setFieldPrompt] = useState("");
  const [customFields, setCustomFields] = useState([]);
  const [loadingAddField, setLoadingAddField] = useState(false);
  const [deletingField, setDeletingField] = useState(null);
  const isMaxFieldsReached = customFields.length >= 5;
  const isFilled = fieldName.trim() && fieldPrompt.trim();
  const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
  const moreButtonRef = useRef(null);
  const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [newFieldName, setNewFieldName] = useState("");
  const [newPrompt, setNewPrompt] = useState("");
  const uploadButtonRef = useRef(null);
  const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });

  const [customFieldPopup, setCustomFieldPopup] = useState({
    visible: false,
    value: "",
    contractKey: "",
    contractId: "",
    x: 0,
    y: 0,
  });
  const popupRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;
    setFile(selectedFiles);
    setIsModalOpen(true);
  };

  const loadGoogleAPI = () => {
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/api.js";
    script.async = true;
    script.onload = () => {
      window.gapi.load("client:picker", () => {
        console.log("Google Picker API is ready.");
      });
    };
    document.body.appendChild(script);
  };

  useEffect(() => {
    loadGoogleAPI();
  }, []);

  useEffect(() => {
    const cookieToken = Cookies.get("access_token");
    if (cookieToken) {
      setToken(cookieToken);
    } else {
      console.error("Access token missing from cookies");
    }
  }, []);

  const toggleModal = () => setIsModalOpen((prev) => !prev);

  const handleExport = async () => {
    if (!selectedinvoices || selectedinvoices.length === 0) {
      showPopup("Error", "Please select at least one invoice to export.");
      return;
    }
    setExportInProgress(true);
    try {
      const response = await api.post(
        `api/v1/invoice/export-invoice/`,
        { invoice_keys: selectedContractKeys },
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoices_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setSelectedinvoices([]);
      setSelectedContractKeys([]);
      setIsBulkDelete(false);
    } catch (error) {
      if (error.response) {
        showPopup("Error", error.response.data?.msg || "Failed to export invoices.");
      } else {
        showPopup("Error", "An unexpected error occurred. Please try again.");
      }
    } finally {
      setExportInProgress(false);
    }
  };

  const handleCancel = () => {
    setSelectedinvoices([]);
    setSelectedContractKeys([]);
    setIsModalOpen(false);
    setIsFilterModalOpen(false);
    setPopupVisible(false);
    setConfirmDeleteVisible(false);
  };

  const handleToggleMore = () => {
    if (isActionMenuOpen === "more") {
      setIsActionMenuOpen(null);
    } else {
      const rect = moreButtonRef.current.getBoundingClientRect();
      setDropdownCoords({
        top: rect.bottom + window.scrollY + 6,
        left: rect.left + window.scrollX - 40,
      });
      setIsActionMenuOpen("more");
    }
  };

  const handleDeleteField = async (fieldId) => {
    try {
      await api.delete(`/api/v1/invoice/delete-field/${fieldId}/`);
      await fetchCustomFields();
    } catch (error) {
      console.error("Error deleting field", error);
    } finally {
      setDeletingField(null);
    }
  };

  useEffect(() => {
    if (isConnected && !hasOpenedPickerOnce) {
      setHasOpenedPickerOnce(true);
    }
  }, [isConnected, hasOpenedPickerOnce]);

  const handleAddFromDriveClick = () => {
    openPicker(async (docs) => {
      try {
        const files = await Promise.all(
          docs.map(async (doc) => {
            const res = await fetch(`https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`, {
              headers: { Authorization: `Bearer ${accessToken}` },
            });
            if (!res.ok) throw new Error("Failed to fetch file from Drive");
            const blob = await res.blob();
            return new File([blob], doc.name, { type: blob.type });
          })
        );
        setFile(files);
        setIsModalOpen(true);
      } catch (err) {
        toast.error("Something went wrong while processing selected files.");
      }
    });
  };

  const handleAddField = async () => {
    if (!fieldName.trim() || !fieldPrompt.trim()) return;
    try {
      setLoadingAddField(true);
      await api.post("/api/v1/invoice/create-field/", {
        field: fieldName.trim(),
        description: fieldPrompt.trim(),
      });
      setFieldName("");
      setFieldPrompt("");
      await fetchCustomFields();
      await fetchinvoices();
      setFieldCreationSuccess(true);
      setTimeout(() => setFieldCreationSuccess(false), 5000);
      setSelectedTab("manage");
      setIsCustomFieldModalOpen(false);
    } catch (error) {
      console.error("Error adding field", error);
    } finally {
      setLoadingAddField(false);
    }
  };

  const fetchinvoices = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      let url = `api/v1/invoice/invoices/`;
      if (isFilterApplied) {
        url = `api/v1/invoice/filter-invoice/`;
        const params = {
          filter_type: filterType,
          time_range: timeRange,
          from_date: fromDate,
          to_date: toDate,
        };
        const response = await api.get(url, { params });
        setinvoices(response.data.invoices || []);
      } else {
        const response = await api.get(url);
        setinvoices(response.data);
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
    } finally {
      setLoading(false);
    }
  }, [token, isFilterApplied, filterType, timeRange, fromDate, toDate]);

  const handleSelectAll = () => {
    if (selectedinvoices.length === invoices.length && invoices.length > 0) {
      setSelectedinvoices([]);
      setSelectedContractKeys([]);
    } else {
      setSelectedinvoices(invoices.map((contract) => contract.id));
      setSelectedContractKeys(invoices.map((contract) => contract.key));
    }
  };

  const filteredinvoices = useMemo(() => {
    const query = searchQuery?.toLowerCase() || "";
    return invoices.filter((invoice) => {
      const invoiceName = invoice?.name?.toLowerCase() || "";
      const customerName = invoice?.details?.["Customer name"]?.toLowerCase() || "";
      const vendorName = invoice?.details?.["Vendor name"]?.toLowerCase() || "";
      return invoiceName.includes(query) || customerName.includes(query) || vendorName.includes(query);
    });
  }, [invoices, searchQuery]);

  const handleCheckboxChange = (id, key) => {
    if (selectedinvoices.includes(id)) {
      setSelectedinvoices(selectedinvoices.filter((contractId) => contractId !== id));
      setSelectedContractKeys(selectedContractKeys.filter((contractKey) => contractKey !== key));
    } else {
      setSelectedinvoices([...selectedinvoices, id]);
      setSelectedContractKeys([...selectedContractKeys, key]);
    }
  };

  useEffect(() => {
    if (token) fetchinvoices();
  }, [fetchinvoices, token, isFilterApplied, filterType, timeRange, fromDate, toDate]);

  useEffect(() => {
    if (isFilterApplied) {
      localStorage.setItem(
        "invoiceFilter",
        JSON.stringify({ filterType, timeRange, fromDate, toDate })
      );
    }
  }, [isFilterApplied, filterType, timeRange, fromDate, toDate]);

  const formatDates = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleUploadSuccess = () => {
    fetchinvoices();
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
    fetchinvoices();
  };

  const toggleActionMenu = (index, event) => {
    event.stopPropagation();
    const menuHeight = 110;
    const rect = event.currentTarget.getBoundingClientRect();
    const bottomSpace = window.innerHeight - rect.bottom;
    const openUpwards = bottomSpace < menuHeight;

    setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
    setActionMenuPosition({
      top: openUpwards ? rect.top - menuHeight : rect.bottom + 5,
      left: rect.left - 130,
      openUpwards,
    });
  };

  const toggleFilterModal = () => setIsFilterModalOpen((prev) => !prev);

  const handleViewMore = (invoiceKey) => {
    navigate(`/Invoices/Invoice_Details/${invoiceKey}`);
  };

  const enableEdit = (invoice) => {
    if (invoice) {
      setIsActionMenuOpen(null);
      setEditContractId(invoice.id);

      const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        const parsedDate = new Date(dateString);
        if (isNaN(parsedDate.getTime())) return "";
        const year = parsedDate.getFullYear();
        const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
        const day = String(parsedDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const extractAmountAndCurrency = (amount) => {
        if (!amount) return { value: "", currency: "" };
        const match = amount.toString().match(/^([\D]*)([\d,\.]+)$/);
        if (match) {
          return { currency: match[1].trim(), value: match[2].trim().replace(",", ".") };
        }
        return { value: amount, currency: "" };
      };

      const { value, currency } = extractAmountAndCurrency(invoice.details?.["Total due amount"]);

      setEditedContractData({
        ...invoice,
        details: {
          ...invoice.details,
          "Issued on": formatDateForInput(invoice.details?.["Issued on"]),
          "Due date": formatDateForInput(invoice.details?.["Due date"]),
          "Total due amount": value,
          Currency: currency,
        },
      });
      setInvoiceName(invoice.name || "");
    } else {
      setEditContractId(null);
      setEditedContractData({});
      setInvoiceName("");
    }
  };

  useEffect(() => {
    fetchCustomFields();
  }, []);

  const fetchCustomFields = async () => {
    try {
      setCustomFieldsLoading(true);
      const res = await api.get("/api/v1/invoice/list-field/");
      setCustomFields(res.data || []);
    } catch (err) {
      console.error("Error fetching fields", err);
    } finally {
      setCustomFieldsLoading(false);
    }
  };

  const handleApplyField = async () => {
    setIsLoading(true);
    const selectedFieldObj = customFields.find((field) => field.field === selectedField);
    const payload = isCreatingNew
      ? {
          new_field: { field: newFieldName, description: newPrompt },
          invoice_keys: selectedContractKeys,
        }
      : {
          field_id: selectedFieldObj?.id,
          invoice_keys: selectedContractKeys,
        };

    if (!isCreatingNew && !payload.field_id) {
      console.error("Invalid field selected.");
      setIsLoading(false);
      return;
    }

    try {
      await api.post("api/v1/invoice/apply-field/", payload);
      setIsCustomApplyFiledModal(false);
      await fetchinvoices();
      await fetchCustomFields();
      setSelectedinvoices([]);
      setSelectedContractKeys([]);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditChange = (fieldPath, value) => {
    if (fieldPath.startsWith("details._custom_fields.")) {
      const key = fieldPath.split(".")[2];
      setEditedContractData((prev) => ({
        ...prev,
        details: {
          ...prev.details,
          _custom_fields: { ...(prev.details?._custom_fields || {}), [key]: value },
        },
      }));
    } else if (fieldPath.startsWith("details.")) {
      const key = fieldPath.split(".")[1];
      setEditedContractData((prev) => ({
        ...prev,
        details: { ...prev.details, [key]: value },
      }));
    } else {
      setEditedContractData((prev) => ({ ...prev, [fieldPath]: value }));
    }
  };

  const handleClickOutside = (event) => {
    if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
      setIsActionMenuOpen(null);
    }
    if (confirmDeleteVisible && event.target.closest(".popup-overlay") === null && !event.target.closest(".popup-box-delete")) {
      setConfirmDeleteVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [confirmDeleteVisible, isActionMenuOpen]);

  useEffect(() => {
    if (editContractId) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [editContractId]);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => setPopupVisible(false);

  const handleDelete = (contractId) => {
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete(contractId);
    setConfirmDeleteVisible(true);
  };

  const handleBulkDelete = () => {
    if (!selectedinvoices || selectedinvoices.length === 0) return;
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  };

  const handleEditSave = async (invoiceId, invoiceKey) => {
    const customFieldsData = editedContractData.details?._custom_fields || {};
    const formattedAmount = editedContractData.details?.["Currency"]
      ? `${editedContractData.details["Currency"]}${editedContractData.details["Total due amount"]}`
      : editedContractData.details?.["Total due amount"];

    const editedData = {
      "Issued on": editedContractData.details?.["Issued on"],
      "Customer name": editedContractData.details?.["Customer name"],
      "Vendor name": editedContractData.details?.["Vendor name"],
      "Total due amount": formattedAmount,
      "Due date": editedContractData.details?.["Due date"],
      _custom_fields: customFieldsData,
    };

    try {
      const response = await api.post(`api/v1/invoice/edit-invoice-details/${invoiceKey}/`, {
        edited_data: editedData,
        note: "Updated invoice details",
        invoice_name: invoice_name,
      });

      if (response.status === 200) {
        const updatedInvoice = response.data.data;
        setinvoices((prev) =>
          prev.map((invoice) =>
            invoice.id === invoiceId ? { ...invoice, name: invoice_name, details: updatedInvoice } : invoice
          )
        );
        setEditContractId(null);
        setRenameSuccessRowId(invoiceId);
        setTimeout(() => setRenameSuccessRowId(null), 3000);
      }
    } catch (error) {
      console.error("Error saving invoice:", error);
      showPopup("Error", "Failed to update invoice. Please try again.");
    }
  };

  const confirmDelete = async () => {
    const idsToDelete = isBulkDelete ? selectedinvoices : [contractToDelete];
    setDeleteInProgress(true);

    try {
      const response = await api.delete(`api/v1/invoice/delete-invoice/`, {
        data: { invoice_ids: idsToDelete },
      });

      const { Deleted_invoices = [], Failed_deletions = [] } = response.data;
      if (Deleted_invoices.length > 0) {
        setinvoices((prev) => prev.filter((invoice) => !Deleted_invoices.includes(invoice.id)));
        if (isBulkDelete) {
          setSelectedinvoices([]);
          setSelectedContractKeys([]);
        }
      }

      if (Failed_deletions.length > 0) {
        const failureMessages = Failed_deletions.map(
          (failure) => `Invoice ID ${failure.invoice_id}: ${failure.error}`
        ).join("\n");
        showPopup("Deletion Failed", failureMessages);
      }
    } catch (error) {
      console.error("Error deleting invoices:", error);
      showPopup("Error", "Failed to delete invoice(s). Please try again.");
    } finally {
      setDeleteInProgress(false);
      setConfirmDeleteVisible(false);
      setIsBulkDelete(false);
      setContractToDelete(null);
      fetchinvoices();
    }
  };

  const [isTooltipVisibleCustomField, setIsTooltipVisibleCustomField] = useState(false);

  const tableColSpan = 8 + customFields.length;

  return (
    <div className="max-w-full overflow-x-hidden flex flex-col flex-grow font-outfit">
      <div>
        <Header name="Invoices" icon={""} isMenuOpen={isMenuOpen} />
      </div>

      <div className="w-full pl-2 pr-1 mt-4">
        <div className="w-[99%] ml-1">
          {/* Top Controls Row */}
          <div className="flex justify-between items-center w-full px-2 mb-4">
            {/* Left: Search and Filter */}
            <div className="flex items-center gap-3">
              <div
                className={`flex w-[380px] h-[40px] px-4 py-2 items-center gap-2 shrink-0 rounded-[24px] bg-white transition-all duration-200 overflow-hidden ${
                  isSearchFocused
                    ? "border border-[#BB42AE]/36 shadow-[0_11px_3px_transparent,0_7px_3px_rgba(0,0,0,0.01),0_4px_2px_rgba(0,0,0,0.05),0_2px_2px_rgba(0,0,0,0.09),0_0_1px_rgba(0,0,0,0.10)]"
                    : "border border-black/10"
                }`}
              >
                <img src="/search.svg" alt="Search" className="w-[18px] h-[18px] flex-shrink-0 opacity-70" />
                <input
                  type="text"
                  placeholder="Search Invoices Here"
                  className="font-outfit text-[14px] font-normal border-none outline-none w-full text-[#171717] bg-transparent whitespace-nowrap placeholder:text-gray-400"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setIsSearchFocused(true)}
                  onBlur={() => setIsSearchFocused(false)}
                />
              </div>

              <div className="relative group inline-block">
                <button
                  className={`flex items-center justify-center gap-2 h-[40px] px-5 rounded-[24px] bg-white transition-all duration-200 ${
                    isFilterApplied ? "border border-[#BB42AE]/36 shadow-sm" : "border border-black/10"
                  }`}
                  onClick={toggleFilterModal}
                >
                  <img src="/filter-icon-first.svg" alt="Filter Icon" className="w-[16px] h-[16px] flex-shrink-0" />
                  <span className="font-outfit text-[#171717] text-[14px] font-medium">Filter</span>
                </button>
                {isFilterApplied && (
                  <img
                    src="/Filter_CTA.svg"
                    alt="Clear Filter"
                    className="absolute -bottom-1 -right-1 w-[18px] h-[18px] cursor-pointer z-10 bg-white rounded-full shadow-sm hover:scale-110 transition-transform"
                    onClick={() => {
                      setIsFilterApplied(false);
                      fetchinvoices();
                    }}
                  />
                )}
              </div>
            </div>

            {/* Right: Actions / Upload */}
            <div className="flex items-center gap-2 flex-wrap justify-end">
              {selectedinvoices.length > 0 ? (
                <>
                  <span className="bg-[#F8F3FF] text-[#C95EBE] text-sm px-3 py-1.5 rounded-full font-medium font-outfit border border-[#C95EBE]/20">
                    {selectedinvoices.length} Invoice selected
                  </span>

                  <button
                    className="bg-[#C95EBE] text-white text-[14px] font-outfit font-medium px-4 py-2 rounded-[8px] hover:bg-[#b04b9e] transition-colors"
                    onClick={() => setIsCustomApplyFiledModal(true)}
                  >
                    Apply Custom Field
                  </button>

                  <div className="relative">
                    <button
                      ref={moreButtonRef}
                      onClick={handleToggleMore}
                      className="border border-black/10 bg-white text-[#52525B] text-[14px] font-outfit font-medium px-4 py-2 rounded-[8px] flex items-center gap-2 hover:bg-gray-50 transition-colors"
                    >
                      More
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    {isActionMenuOpen === "more" && (
                      <div
                        className="fixed z-[9999] bg-white rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.12)] border border-gray-100 p-1.5 min-w-[140px] font-outfit"
                        style={{ top: `${dropdownCoords.top}px`, left: `${dropdownCoords.left}px` }}
                      >
                        <button
                          onClick={handleExport}
                          disabled={exportInProgress}
                          className="flex items-center gap-2.5 px-3 py-2 text-[14px] font-medium rounded-[8px] w-full hover:bg-[#F0F7FF] text-[#0066FF] disabled:opacity-60 transition-colors"
                        >
                          <img src="/export-icon-blue.svg" alt="Export" className="w-4 h-4" />
                          {exportInProgress ? "Exporting..." : "Export"}
                        </button>
                        <button
                          onClick={handleBulkDelete}
                          className="flex items-center gap-2.5 px-3 py-2 mt-0.5 text-[14px] font-medium rounded-[8px] w-full hover:bg-[#FFF0F0] text-[#E21919] transition-colors"
                        >
                          <img src="/delete-icon-red.svg" alt="Delete" className="w-4 h-4" />
                          Delete
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    onClick={handleCancel}
                    className="flex items-center justify-center p-[8px] rounded-[8px] border border-black/10 bg-[#F4F4F5] hover:bg-[#E4E4E7] transition-colors"
                  >
                    <img src="/cancel_icon.svg" alt="Cancel" className="w-[16px] h-[16px]" />
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-[8px] hover:bg-gray-50 transition-colors shadow-sm"
                    onClick={() => setIsCustomFieldModalOpen(true)}
                  >
                    <img src="/custom-field-icons.svg" alt="Custom Field" className="w-[18px] h-[18px]" />
                    <span className="text-[#52525B] font-outfit text-[14px] font-medium">Custom Field</span>
                  </button>

                  <div className="relative inline-block">
                    <button
                      ref={uploadButtonRef}
                      className="flex items-center justify-center gap-2 px-[22px] py-[9px] bg-[#C95EBE] rounded-[8px] text-white font-outfit text-[14px] font-medium hover:bg-[#b04b9e] transition-colors shadow-sm"
                      onClick={() => setIsTooltipVisibleCustomField(!isTooltipVisibleCustomField)}
                    >
                      <img src="/upload_icon_white.svg" alt="Upload" className="w-[18px] h-[18px]" />
                      Upload Invoice
                    </button>

                    {isTooltipVisibleCustomField && (
                      <div className="absolute top-[115%] right-0 w-[188px] bg-white shadow-lg border border-gray-100 rounded-[12px] p-2 z-[1000] text-left">
                        <div
                          className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors"
                          onClick={() => {
                            setIsTooltipVisibleCustomField(false);
                            fileInputRef.current.click();
                          }}
                        >
                          <img src="/upload-icon.svg" alt="Upload" className="w-4 h-4" />
                          Add from device
                        </div>

                        {!isConnected ? (
                          <div
                            className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors mt-1"
                            onClick={() => {
                              setIsTooltipVisibleCustomField(false);
                              navigate("/account/integration");
                            }}
                          >
                            <img src="/connect-icon.svg" alt="Connect" className="w-4 h-4" />
                            Connect Drive
                          </div>
                        ) : (
                          <div
                            className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors mt-1"
                            onClick={() => {
                              setIsTooltipVisibleCustomField(false);
                              handleAddFromDriveClick();
                            }}
                          >
                            <img src="/picker-icon.svg" alt="Drive" className="w-4 h-4" />
                            Add from Drive
                          </div>
                        )}
                      </div>
                    )}

                    <input
                      ref={fileInputRef}
                      type="file"
                      multiple
                      className="hidden"
                      accept=".pdf,.xls,.xlsx,.csv,.txt,.doc,.jpeg,.jpg,.png,.webp,.bmp"
                      onChange={handleFileChange}
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* TABLE UI Area */}
          <div className="relative overflow-auto custom-scrollbar w-full" style={{ height: "calc(100vh - 200px)" }}>
            <table className="w-full text-sm text-left table-auto border-separate border-spacing-0">
              <thead className="bg-white h-12 text-[#1E1E1E] font-medium">
                <tr>
                  <th className="w-[40px] px-3 sticky top-0 bg-white z-20 border-b border-black/10 align-middle text-center">
                    <input
                      type="checkbox"
                      className="custom-checkbox mx-auto"
                      style={{
                        appearance: "none",
                        border: "1.5px solid #c0c0c0",
                        borderRadius: "4px",
                        cursor: "pointer",
                        width: "18px",
                        height: "18px",
                        backgroundImage:
                          selectedinvoices.length === invoices.length && invoices.length > 0
                            ? "url('/checck.svg')"
                            : "none",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "14px 14px",
                        display: "block",
                      }}
                      onChange={handleSelectAll}
                      checked={selectedinvoices.length === invoices.length && invoices.length > 0}
                    />
                  </th>
                  <th className="min-w-[180px] px-2 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Invoice Name</span>
                  </th>
                  <th className="min-w-[140px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Customer Name</span>
                  </th>
                  <th className="min-w-[140px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Vendor Name</span>
                  </th>
                  <th className="min-w-[120px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Amount</span>
                  </th>
                  
                  {customFields.map((field, index) => (
                    <th key={index} className="min-w-[130px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                      <span className="inline-flex items-center gap-1.5">
                        <span className="truncate">{field.field}</span>
                        <img src="/invoice-bulblogo-invoicee.svg" alt="Custom" className="w-3.5 h-3.5 flex-shrink-0" />
                      </span>
                    </th>
                  ))}

                  <th className="min-w-[120px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Date Issued</span>
                  </th>
                  <th className="min-w-[120px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Due Date</span>
                  </th>
                  <th className="min-w-[100px] px-3 py-2 align-middle text-center text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Actions</span>
                  </th>
                </tr>
              </thead>

              <tbody className="bg-white">
                {loading ? (
                  <tr>
                    <td colSpan={tableColSpan} className="py-20 border-b border-black/10 bg-white">
                      <div className="text-center flex flex-col items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C95EBE] mx-auto mb-4"></div>
                        <p className="text-[#52525B] font-outfit text-[15px]">Loading Invoices...</p>
                      </div>
                    </td>
                  </tr>
                ) : filteredinvoices.length > 0 ? (
                  filteredinvoices.map((contract, index) => (
                    <tr
                      key={contract.id || index}
                      ref={editContractId === contract.id ? editRowRef : null}
                      className="group cursor-pointer hover:bg-[#F8F3FF] transition-colors h-[48px]"
                    >
                      <td className="px-3 py-2 align-middle text-center border-b border-black/10">
                        <input
                          type="checkbox"
                          className="custom-checkbox mx-auto"
                          style={{
                            appearance: "none",
                            border: "1.5px solid #c0c0c0",
                            borderRadius: "4px",
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            backgroundImage: selectedinvoices.includes(contract.id) ? "url('/checck.svg')" : "none",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "14px 14px",
                            display: "block",
                          }}
                          checked={selectedinvoices.includes(contract.id)}
                          onChange={() => handleCheckboxChange(contract.id, contract.key)}
                        />
                      </td>

                      {editContractId === contract.id ? (
                        <>
                          <td className="px-2 py-2 align-middle border-b border-black/10">
                            <input
                              type="text"
                              value={invoice_name}
                              onChange={(e) => setInvoiceName(e.target.value)}
                              className="w-full px-2 py-1 border border-[#C95EBE] rounded-[6px] outline-none font-outfit text-[14px] text-[#171717]"
                              placeholder="Invoice Name"
                            />
                          </td>
                          <td className="px-2 py-2 align-middle border-b border-black/10">
                            <input
                              type="text"
                              value={editedContractData.details?.["Customer name"] || ""}
                              onChange={(e) => handleEditChange("details.Customer name", e.target.value)}
                              className="w-full px-2 py-1 border border-[#C95EBE] rounded-[6px] outline-none font-outfit text-[14px] text-[#171717]"
                            />
                          </td>
                          <td className="px-2 py-2 align-middle border-b border-black/10">
                            <input
                              type="text"
                              value={editedContractData.details?.["Vendor name"] || ""}
                              onChange={(e) => handleEditChange("details.Vendor name", e.target.value)}
                              className="w-full px-2 py-1 border border-[#C95EBE] rounded-[6px] outline-none font-outfit text-[14px] text-[#171717]"
                            />
                          </td>
                          <td className="px-2 py-2 align-middle border-b border-black/10">
                            <input
                              type="text"
                              value={
                                editedContractData.details?.["Currency"]
                                  ? `${editedContractData.details["Currency"]} ${editedContractData.details["Total due amount"]}`
                                  : editedContractData.details?.["Total due amount"] || ""
                              }
                              onChange={(e) => {
                                const rawValue = e.target.value.replace(/[^0-9.,]/g, "");
                                handleEditChange("details.Total due amount", rawValue);
                              }}
                              className="w-full px-2 py-1 border border-[#C95EBE] rounded-[6px] outline-none font-outfit text-[14px] text-[#171717]"
                            />
                          </td>
                          
                          {customFields.map((fieldObj, idx) => (
                            <td key={idx} className="px-2 py-2 align-middle border-b border-black/10">
                              <input
                                type="text"
                                value={editedContractData.details?._custom_fields?.[fieldObj.field] || ""}
                                onChange={(e) => handleEditChange(`details._custom_fields.${fieldObj.field}`, e.target.value)}
                                className="w-full px-2 py-1 border border-[#C95EBE] rounded-[6px] outline-none font-outfit text-[14px] text-[#171717]"
                              />
                            </td>
                          ))}

                          <td className="px-2 py-2 align-middle border-b border-black/10">
                            <input
                              type="date"
                              value={editedContractData.details?.["Issued on"] || ""}
                              onChange={(e) => handleEditChange("details.Issued on", e.target.value)}
                              className="w-full px-2 py-1 border border-[#C95EBE] rounded-[6px] outline-none font-outfit text-[14px] text-[#171717]"
                            />
                          </td>
                          <td className="px-2 py-2 align-middle border-b border-black/10">
                            <input
                              type="date"
                              value={editedContractData.details?.["Due date"] || ""}
                              onChange={(e) => handleEditChange("details.Due date", e.target.value)}
                              className="w-full px-2 py-1 border border-[#C95EBE] rounded-[6px] outline-none font-outfit text-[14px] text-[#171717]"
                            />
                          </td>
                          <td className="px-3 py-2 align-middle text-center border-b border-black/10">
                            <div className="flex items-center justify-center gap-2">
                              <button onClick={() => handleEditSave(contract.id, contract.key)} className="p-1.5 hover:bg-green-50 rounded-full transition-colors">
                                <img src="/save-icon-contracttable.svg" alt="Save" className="w-5 h-5" />
                              </button>
                              <button onClick={() => setEditContractId(null)} className="p-1.5 hover:bg-red-50 rounded-full transition-colors">
                                <img src="/cancel-icon-contracttable.svg" alt="Cancel" className="w-5 h-5" />
                              </button>
                            </div>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="px-2 py-2 align-middle border-b border-black/10 relative">
                            <span
                              className="text-[#B793ED] underline cursor-pointer font-outfit text-[14px] font-medium truncate block w-[95%]"
                              onClick={() => navigate(`/Invoices/Invoice_Details/${contract.key}`)}
                              title={contract.name || "N/A"}
                            >
                              {contract.name?.length > 35 ? `${contract.name.slice(0, 30)}...${contract.name.slice(-5)}` : contract.name || "N/A"}
                            </span>
                            {renameSuccessRowId === contract.id && (
                              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 flex items-center gap-2 px-3 py-1.5 bg-white border border-black/10 rounded-[8px] shadow-sm whitespace-nowrap">
                                <img src="/green-icon-tick.svg" alt="Success" className="w-4 h-4" />
                                <span className="text-[#52525B] font-outfit text-[13px]">Changes applied</span>
                              </div>
                            )}
                          </td>
                          <td className="px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10">
                            {contract.details?.["Customer name"] || "N/A"}
                          </td>
                          <td className="px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10">
                            {contract.details?.["Vendor name"] || "N/A"}
                          </td>
                          <td className="px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10">
                            {contract.details?.["Total due amount"] || "N/A"}
                          </td>
                          
                          {customFields.map((fieldObj, idx) => {
                            const fieldValue = contract.details?._custom_fields?.[fieldObj.field] || "N/A";
                            return (
                              <td key={idx} className="px-3 py-2 align-middle border-b border-black/10">
                                <span
                                  className="text-[#B793ED] cursor-pointer block truncate w-full font-outfit text-[14px] font-medium"
                                  onMouseEnter={(e) => {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setCustomFieldPopup({
                                      visible: true,
                                      value: fieldValue,
                                      contractKey: contract.key,
                                      contractId: contract.id,
                                      x: rect.left + window.scrollX,
                                      y: rect.bottom + window.scrollY + 8,
                                    });
                                  }}
                                  onMouseLeave={() => {
                                    setTimeout(() => {
                                      if (popupRef.current && !popupRef.current.matches(":hover")) {
                                        setCustomFieldPopup((prev) => ({ ...prev, visible: false }));
                                      }
                                    }, 150);
                                  }}
                                >
                                  {fieldValue.length > 15 ? `${fieldValue.slice(0, 15)}...` : fieldValue}
                                </span>
                              </td>
                            );
                          })}

                          <td className="px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10 whitespace-nowrap">
                            {formatDates(contract.details?.["Issued on"])}
                          </td>
                          <td className="px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10 whitespace-nowrap">
                            {formatDates(contract.details?.["Due date"])}
                          </td>
                          <td className="px-3 py-2 align-middle text-center border-b border-black/10">
                            <div
                              className="flex items-center justify-center w-8 h-8 mx-auto rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                              onClick={(e) => toggleActionMenu(index, e)}
                            >
                              <img src="/action.svg" alt="Actions" className="w-5 h-5" />
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={tableColSpan} className="py-16 text-center bg-white border-b border-black/10">
                      <div className="flex flex-col items-center justify-center">
                        <img src="/no-contracts.svg" alt="No Documents Found" className="mb-4 w-[120px] h-[120px]" />
                        <p className="text-[#52525B] font-outfit text-[15px]">Looks like your Table is empty!</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Row Action Menu Popup */}
      {isActionMenuOpen !== null && isActionMenuOpen !== "more" && (
        <div
          className="fixed z-[9999] bg-white rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.12)] border border-gray-100 p-1.5 min-w-[140px] font-outfit"
          ref={actionMenuRef}
          style={{ top: `${actionMenuPosition.top}px`, left: `${actionMenuPosition.left}px` }}
        >
          <div
            onMouseEnter={() => setHoveredAction("edit")}
            onMouseLeave={() => setHoveredAction(null)}
            onClick={() => enableEdit(filteredinvoices[isActionMenuOpen])}
            className={`flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer transition-colors ${
              hoveredAction === "edit" ? "bg-[#FAF9F6] text-[#C95EBE]" : "text-[#52525B]"
            }`}
          >
            <img src={hoveredAction === "edit" ? "/edit-active-contract.svg" : "/edit.svg"} alt="Edit" className="w-4 h-4" />
            <span className="text-[14px] font-medium">Edit</span>
          </div>

          <div
            onMouseEnter={() => setHoveredAction("delete")}
            onMouseLeave={() => setHoveredAction(null)}
            onClick={() => handleDelete(filteredinvoices[isActionMenuOpen].id)}
            className={`flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer transition-colors mt-0.5 ${
              hoveredAction === "delete" ? "bg-[#FFF0F0] text-[#E21919]" : "text-[#52525B]"
            }`}
          >
            <img src={hoveredAction === "delete" ? "/delete-active-contract.svg" : "/delete.svg"} alt="Delete" className="w-4 h-4" />
            <span className="text-[14px] font-medium">Delete</span>
          </div>
        </div>
      )}

      {/* Apply Custom Field Modal */}
      {isCustomApplyFieldModal && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="relative bg-white rounded-[12px] shadow-xl w-[440px] p-6 animate-[fadeIn_0.2s_ease-out]">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-[#171717] font-outfit text-[18px] font-semibold">Apply Custom Field</h2>
              <button onClick={() => setIsCustomApplyFiledModal(false)} className="text-gray-400 hover:text-gray-600 text-2xl transition-colors">×</button>
            </div>
            
            <div className="mb-6 inline-flex">
               <span className="text-[#C95EBE] bg-[#F8F3FF] border border-[#C95EBE]/20 font-outfit text-[13px] font-medium rounded-full px-3 py-1">
                {selectedinvoices.length} Invoices selected
              </span>
            </div>

            <div className="flex flex-col gap-4 mb-6">
              <label className="flex items-center gap-3 cursor-pointer group">
                <input type="radio" checked={!isCreatingNew} onChange={() => setIsCreatingNew(false)} className="w-4 h-4 text-[#C95EBE] focus:ring-[#C95EBE] cursor-pointer" />
                <span className="text-[#344054] font-outfit text-[14px] font-medium group-hover:text-[#171717] transition-colors">Select from Existing Field</span>
              </label>

              <label className="flex items-start gap-3 cursor-pointer group">
                <input type="radio" checked={isCreatingNew} onChange={() => setIsCreatingNew(true)} className="w-4 h-4 mt-0.5 text-[#C95EBE] focus:ring-[#C95EBE] cursor-pointer" />
                <div className="flex flex-col">
                  <span className="text-[#344054] font-outfit text-[14px] font-medium group-hover:text-[#171717] transition-colors">Create New Field</span>
                  <span className="text-[12px] text-gray-500 font-outfit">({customFields.length}/5 used)</span>
                </div>
              </label>
            </div>

            {isCreatingNew ? (
              <div className="flex flex-col gap-4 mb-6">
                <div>
                  <label className="block text-[#344054] font-outfit text-[14px] font-medium mb-1.5">Field Name</label>
                  <input
                    className="w-full h-[40px] px-3 border border-gray-300 rounded-[8px] outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] text-[14px] font-outfit text-[#171717] transition-all"
                    placeholder="Enter field name"
                    value={newFieldName}
                    onChange={(e) => setNewFieldName(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-[#344054] font-outfit text-[14px] font-medium mb-1.5">Extraction Prompt</label>
                  <textarea
                    className="w-full h-[80px] px-3 py-2 border border-gray-300 rounded-[8px] outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] text-[14px] font-outfit text-[#171717] transition-all resize-none"
                    placeholder="Enter prompt"
                    value={newPrompt}
                    onChange={(e) => setNewPrompt(e.target.value)}
                  />
                </div>
              </div>
            ) : (
              <div className="mb-6">
                <label className="block text-[#344054] font-outfit text-[14px] font-medium mb-1.5">Choose Field</label>
                <div className="relative">
                  <CustomDropdown selected={selectedField} onSelect={setSelectedField} options={customFields.map((f) => f.field)} />
                </div>
              </div>
            )}

            <div className="flex justify-end gap-3 pt-2">
              <button onClick={() => setIsCustomApplyFiledModal(false)} className="px-5 py-2 rounded-[8px] border border-gray-200 text-[#52525B] font-outfit text-[14px] font-medium hover:bg-gray-50 transition-colors">
                Cancel
              </button>
              <button
                onClick={handleApplyField}
                disabled={isLoading}
                className="flex items-center justify-center min-w-[120px] px-5 py-2 rounded-[8px] bg-[#C95EBE] text-white font-outfit text-[14px] font-medium hover:bg-[#b04b9e] transition-colors disabled:opacity-70"
              >
                {isLoading ? <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : isCreatingNew ? "Create & Apply" : "Apply Field"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Manage Custom Fields Modal */}
      {isCustomFieldModalOpen && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="relative bg-white rounded-[12px] shadow-xl w-[500px] p-6 animate-[fadeIn_0.2s_ease-out]">
            <button onClick={() => setIsCustomFieldModalOpen(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl transition-colors">×</button>
            <h2 className="text-[#171717] font-outfit text-[20px] font-semibold mb-1">Custom Fields</h2>
            <p className="text-[#52525B] font-outfit text-[13px] mb-6">You can create up to 5 custom fields.<br/>Deleting a field won't reset the limit.</p>

            <div className="flex gap-6 border-b border-gray-200 mb-6">
              <button
                className={`pb-2 font-outfit text-[14px] font-medium transition-colors relative ${selectedTab === "manage" ? "text-[#C95EBE]" : "text-[#52525B] hover:text-[#171717]"}`}
                onClick={() => setSelectedTab("manage")}
              >
                {customFieldsLoading ? "Loading..." : `Manage Fields (${customFields.length}/5)`}
                {selectedTab === "manage" && <div className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#C95EBE] rounded-t-full" />}
              </button>
              <button
                className={`pb-2 font-outfit text-[14px] font-medium transition-colors relative ${selectedTab === "create" ? "text-[#C95EBE]" : "text-[#52525B] hover:text-[#171717]"}`}
                onClick={() => setSelectedTab("create")}
              >
                Create New Field
                {selectedTab === "create" && <div className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#C95EBE] rounded-t-full" />}
              </button>
            </div>

            {selectedTab === "create" && (
              <div className="flex flex-col gap-4">
                <div>
                  <label className="flex items-center gap-1.5 text-[#344054] font-outfit text-[14px] font-medium mb-1.5">
                    Field name <img src="/bulb.svg" alt="Hint" className="w-3.5 h-3.5 opacity-60" />
                  </label>
                  <input
                    type="text"
                    value={fieldName}
                    onChange={(e) => setFieldName(e.target.value)}
                    placeholder={isMaxFieldsReached ? "Maximum 5 fields allowed." : "Enter field name"}
                    disabled={isMaxFieldsReached}
                    className="w-full h-[40px] px-3 border border-gray-300 rounded-[8px] outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] text-[14px] font-outfit text-[#171717] disabled:bg-gray-50 disabled:text-gray-400 transition-all"
                  />
                </div>
                <div>
                  <label className="flex items-center gap-1.5 text-[#344054] font-outfit text-[14px] font-medium mb-1.5">
                    Extraction Prompt <img src="/bulb.svg" alt="Hint" className="w-3.5 h-3.5 opacity-60" />
                  </label>
                  <textarea
                    value={fieldPrompt}
                    onChange={(e) => setFieldPrompt(e.target.value)}
                    placeholder={isMaxFieldsReached ? "Limit reached." : "Enter extraction prompt"}
                    disabled={isMaxFieldsReached}
                    className="w-full h-[80px] px-3 py-2 border border-gray-300 rounded-[8px] outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] text-[14px] font-outfit text-[#171717] disabled:bg-gray-50 disabled:text-gray-400 transition-all resize-none"
                  />
                </div>
                <button
                  onClick={handleAddField}
                  disabled={!isFilled || loadingAddField || isMaxFieldsReached}
                  className="w-full mt-2 h-[40px] flex items-center justify-center rounded-[8px] bg-[#C95EBE] text-white font-outfit text-[14px] font-medium hover:bg-[#b04b9e] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {loadingAddField ? <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : "Add Field"}
                </button>
              </div>
            )}

            {selectedTab === "manage" && (
              <div className="flex flex-col h-[280px]">
                <div className="grid grid-cols-[1fr_1.5fr_auto] gap-4 px-2 mb-2">
                  <span className="text-[#52525B] font-outfit text-[13px] font-medium uppercase tracking-wider">Field Name</span>
                  <span className="text-[#52525B] font-outfit text-[13px] font-medium uppercase tracking-wider">Prompt</span>
                  <span className="w-[80px]"></span>
                </div>
                
                <div className="overflow-y-auto custom-scrollbar flex-grow pr-2">
                  {customFields.length ? (
                    customFields.map((field, index) => (
                      <div key={index} className="grid grid-cols-[1fr_1.5fr_auto] gap-4 items-start py-3 border-t border-gray-100 group hover:bg-gray-50 px-2 rounded-lg transition-colors">
                        <span className="text-[#171717] font-outfit text-[14px] font-medium break-words leading-tight pt-1">{field.field}</span>
                        <span className="text-[#52525B] font-outfit text-[13px] leading-relaxed break-words">{field.description}</span>
                        <button
                          onClick={() => { setDeletingField(field.id); handleDeleteField(field.id); }}
                          disabled={deletingField === field.id}
                          className="flex items-center justify-center gap-1.5 px-2 py-1.5 rounded bg-red-50 text-red-600 hover:bg-red-100 font-outfit text-[12px] font-medium transition-colors disabled:opacity-50"
                        >
                          {deletingField === field.id ? "Deleting..." : <>Delete <img src="/delete-icon-red.svg" alt="Delete" className="w-3 h-3" /></>}
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="flex flex-col items-center justify-center h-[150px] text-[#52525B] font-outfit text-[14px]">
                      No custom fields available.
                    </div>
                  )}
                </div>

                <div className="pt-4 mt-auto border-t border-gray-100 flex justify-end">
                  <button onClick={async () => { await fetchinvoices(); setIsCustomFieldModalOpen(false); }} className="px-6 py-2 rounded-[8px] bg-[#C95EBE] text-white font-outfit text-[14px] font-medium hover:bg-[#b04b9e] transition-colors">
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Tooltip for custom fields row data */}
      {customFieldPopup.visible && (
        <div
          ref={popupRef}
          className="fixed z-[9999] bg-white border border-gray-200 rounded-[8px] shadow-lg p-3 w-max max-w-[300px] font-outfit animate-[fadeIn_0.15s_ease-out]"
          style={{ top: `${customFieldPopup.y}px`, left: `${customFieldPopup.x}px` }}
          onMouseEnter={() => setCustomFieldPopup((prev) => ({ ...prev, visible: true }))}
          onMouseLeave={() => setCustomFieldPopup((prev) => ({ ...prev, visible: false }))}
        >
          <p className="text-[#171717] text-[13px] leading-relaxed font-medium break-words whitespace-normal m-0">
            {customFieldPopup.value}
          </p>
          <button
            onClick={() => handleViewMore(customFieldPopup.contractKey)}
            className="text-[#C95EBE] text-[13px] font-medium underline mt-2 hover:text-[#b04b9e] transition-colors bg-transparent border-none p-0 cursor-pointer"
          >
            View More
          </button>
        </div>
      )}

      {/* Success Toast */}
      {fieldCreationSuccess && (
        <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[11000] flex items-center gap-3 p-4 bg-white border border-gray-100 shadow-2xl rounded-[12px] animate-[slideUp_0.3s_ease-out]">
          <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
            <img src="/green-icon-tick.svg" alt="Success" className="w-4 h-4" />
          </div>
          <span className="text-[#171717] font-outfit text-[14px] font-medium">Field Created successfully. Select documents to apply this field.</span>
        </div>
      )}

      {/* Standard Popup/Alerts */}
      {popupVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center animate-[fadeIn_0.2s_ease-out]">
            <h2 className="text-[#171717] font-outfit text-[18px] font-semibold mb-3">{popupTitle}</h2>
            <p className="text-[#52525B] font-outfit text-[14px] leading-relaxed mb-6">{popupMessage}</p>
            <button className="bg-[#C95EBE] hover:bg-[#b04b9e] text-white font-outfit text-[14px] font-medium px-6 py-2.5 rounded-[8px] transition-colors" onClick={closePopup}>
              Close
            </button>
          </div>
        </div>
      )}

      {confirmDeleteVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center animate-[fadeIn_0.2s_ease-out]">
            <h2 className="text-[#171717] font-outfit text-[18px] font-semibold mb-3">Are you sure you want to delete the selected invoice?</h2>
            <p className="text-[#52525B] font-outfit text-[14px] leading-relaxed mb-6">
              Once deleted, the selected item(s) will be permanently removed. This action cannot be undone.
            </p>
            <div className="flex gap-3 justify-center">
              <button onClick={() => setConfirmDeleteVisible(false)} disabled={deleteInProgress} className="px-6 py-2.5 rounded-[8px] border border-gray-200 text-[#52525B] font-outfit text-[14px] font-medium hover:bg-gray-50 transition-colors">
                Cancel
              </button>
              <button onClick={confirmDelete} disabled={deleteInProgress} className="px-6 py-2.5 rounded-[8px] bg-red-600 text-white font-outfit text-[14px] font-medium hover:bg-red-700 transition-colors disabled:opacity-70">
                {deleteInProgress ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      <UploadModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onUploadSuccess={handleUploadSuccess}
        type={"Invoices"}
        file={file}
      />

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        token={token}
        setInvoices={(filtered) => {
          setinvoices(filtered);
          setIsFilterApplied(true);
          setIsFilterModalOpen(false);
        }}
        isInvoice={true}
        fetchinvoices={fetchinvoices}
        setIsFilterApplied={setIsFilterApplied}
      />
    </div>
  );
};

export default ContractTable;
